import { Timestamp } from 'firebase/firestore';
import { UserTimestamp } from './User';
import {ThemePalette} from '@angular/material/core';

export class AventiFile {
  public id?: string;
  public ids?: string[];
  public parentid?: string;
  public projectid?: string;
  public objectid?: string;
  public checklistid?: string;
  public checklistitemid?: string;
  public path?: string;
  public storagepath?: string;
  public storagename?: string;
  public storagename200?: string;
  public storagename500?: string;
  public downloadurl?: string;
  public thumbnailName?: string;
  public thumbnailpath?: string;
  public thumbnailPath?: string;
  public thumbnailUrl?: string;
  public name?: string;
  public type?: string;
  public typestring?: string;
  public editedBy?: UserTimestamp[];
  public timestamporiginal?: Timestamp;
  public timestamp?: Timestamp;
  public timestampstring?: string;
  public lastupdated?: UserTimestamp;
  public lastupdatedString?: string;
  public base64?: string;
  public width?: number;
  public height?: number;
  public aspectratio?: number; // width / height
  public fileextention?: string;
  public downloadurl200?: string;
  public downloadurl500?: string;
  public image?: string;
  public iconcolor?: ThemePalette;
  public sizeB?: number;
  public sizeMB?: number;
  public sizestring?: string;
  public comment?: string;
  public checklistcomment?: string;
  public data?: any;
  public exif?: any;
  public isdeviationsign?: boolean;
  public numberOfDeviations?: number;
  public numberOfDeviationsSigned?: number;
  public exportQuality?: number; // Max image size in exported PDF, in kB
  // public arraybuffer: ArrayBuffer;
  // public fileToAppend: jsPDF;

  /** Not stored in DB, only used for name generation in flight when exporting */
  public fileName?: string;
}

export const AVENTI_LOGO_BASE64 = `data:image/png;base64,
  iVBORw0KGgoAAAANSUhEUgAABnkAAAGbCAIAAACH1mJgAAAABGdBTUEAALGPC/xhBQAAAAlwSFlz
  AAAXDgAAFw4B9fxN7wAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC45bDN+TgAAt1ZJREFU
  eF7svQdYVVua5k9V3a6qrqpO1dVpOkzPdM9MT0/omU7T0/+ePNPXeJUskoMEAyjmnHMgSDBnOYcM
  ooIBkKAEFQMCknPOGQ7ncP8fnFW2tfV6Fdlrr7PP+3ve8vFayvpW2Pus7z0rWHwNAAAAAAAAAAAA
  AACYDeC1AQAAAAAAAAAAAAAwO8BrAwAAAAAAAAAAAABgdoDXBgAAAAAAAAAAAADA7ACvDQAAAAAA
  AAAAAACA2QFeGwAAAAAAAAAAAAAAswO8NgAAAAAAAAAAAAAAZgd4bQAAAAAAAAAAAAAAzA7w2gAA
  AAAAAAAAAAAAmB3gtQEAAAAAAAAAAAAAMDvAawMAAAAAAAAAAAAAYHaA1wYAAAAAAAAAAAAAwOwA
  rw0AAAAAAAAAAAAAgNkBXhsAAAAAAAAAAAAAALMDvDYAAAAAAAAAAAAAAGYHeG0AAAAAAAAAAAAA
  AMwO8NoAAAAAAAAAAAAAAJgd4LUBAAAAAAAAAAAAADA7wGsDAAAAAAAAAAAAAGB2gNcGAAAAAAAA
  AAAAAMDsAK8NAAAAAAAAAAAAAIDZAV4bAAAAAAAAAAAAAACzA7w2AAAAAAAAAAAAAABmB3htAAAA
  AAAAAAAAAADMDvDaAAAAAAAAAAAAAACYHeC1AQAAAAAAAAAAAAAwO8BrAwAAAAAAAAAAAABgdoDX
  BgAAAAAAAAAAAADA7ACvDQAAAAAAAAAAAACA2QFeGwAAAAAAAAAAAAAAswO8NgAAAAAAAAAAAAAA
  Zgd4bQAAAAAAAAAAAAAAzA7w2gAAAAAAAAAAAAAAmB3gtQEAAAAAAAAAAAAAMDvAawMAAAAAAAAA
  AAAAYHaA1wYAAAAAAAAAAAAAwOwArw2YJJNfT05M6gcnRjvH+huGO2uH2qoHW6sGWyoGmsshc9Xr
  gSYaEmyIAAAAAAAAAAAASgCvDQjHqH68VzfUNNL1rLc6rbXoam3m8ddJ659f9CgMtXt0ZF727v+R
  sfkv7675s9t+/+Lmsj+44f7bSc4/S3L6zUTHnyYu/Q1SggNknvr1OJubzY/ZMAIAAAAAAAAAAJQA
  XhtQknHDRPNI94ve2uTmgqNlCd6Pw+dm7/rLu2v+MMXjVxOW/CDW+jvRX1lo5llc/9IiijRnWnMt
  NKR505pvoSUtgKApXf/HhMZHbGwBAAAAAAAAAABKAK8NcKVXN/S4u+JqXeamF5ctcw/89d3AP0zx
  +H6slYV24ZRxZjTRtAssohdaRH8FQZ+mqDmJjXlsqAEAAAAAAAAAAEoArw3IS8/44LPemit1Geue
  X/y/D7b/UYrnD2Otp9amsRVqRmftHdMEgmYgeG0AAAAAAAAAAJQGXhuYfdrHerM6iveWRM/P3vPP
  Uzynlq1p5k1tAtXMnd7yiTVrkDyC1wYAAAAAAAAAQGngtYHZoXd8KLvj1bHXiQtz9v6Lm17fiV7E
  jlSDswZxE7w2AAAAAAAAAABKA68NzBzD5GTlYMuZqjTbh4f+KMXzi5jFUztDjYvXJCYIBHEQvDYA
  AAAAAAAAAEoDrw18MqP68SfdlQdKY/5XxtZfSbCfMtei5kz7a1jCBikqeG0AAAAAAAAAAJQGXhv4
  WEb145ntLzc+v/hXd9dM3W9gvDNUYnZAkIKC1wYAAAAAAAAAQGngtYFvYWJSX9RTvaP4+n+64/+9
  mEXTVxzMwxI2SETBawMAAAAAAAAAoDTw2sA3UjnYElx+47+lb/pBrDUsNsgEBK8NAAAAAAAAAIDS
  wGsDUgYmRuIaH1rlHvhZ4lJsFIVMSfDaAAAAAAAAAAAoDbw28E9UDrTsfaX9d6krLDTzLaauO1gg
  9TIgSGTBawMAAAAAAAAAoDTw2sDXo3rdvbZnzvknfprgMGWxYa8oZKKC1wYAAAAAAAAAQGngtZk1
  XeP9Z6vv/H/3N3wvepFF1FwLLSw2yJQFrw0AAAAAAAAAgNLAazNTWkd6DpfG/atb3lOr2DRzsZAN
  UoPgtQEAAAAAAAAAUBp4bWZH7VD7jlfX/zjFa8plw0I2SE2C1wYAAAAAAAAAQGngtZkRpf0Na56d
  +50k56lD2XDvAaQ+wWsDAAAAAAAAAKA08NrMgvKBphVPIn8jYQlcNkjNgtcGAAAAAAAAAEBp4LWp
  nOaR7m3F134nyQm3i0LqF7w2AAAAAAAAAABKA69NtfSMDx4tS/jjFE+sZYPMRfDaAAAAAAAAAAAo
  Dbw2FTI4MXqu5t6f314+7bLNl/oREKRWwWsDAAAAAAAAAKA08NrUxp3Wov/v/vqphWxYywaZm+C1
  AQAAAAAAAABQGnht6qFioNmjMOSXYhZbaOZKPQgIMgfBawMAAAAAAAAAoDTw2tTAwMTI8ddJv5fk
  PL1pFBcgQOYqeG0AAAAAAAAAAJQGXpvJc6e16O/vr5+6ZhSbRiEzF7w2AAAAAAAAAABKA6/NhGkY
  7vQsDP0iZtGU0SYxHSDIDAWvDQAAAAAAAACA0sBrM0kmJye1Ddn/IsULm0Yh6J8Erw0AAAAAAAAA
  gNLAazM9GqeWs4V8Ef2VhXa+1GuAIHMWvDYAAAAAAAAAAEoDr83EiGnI/dOb08vZorGcDYJ+UfDa
  AAAAAAAAAAAoDbw2k6FxuNO9IOS70QtxOhsEvV/w2gAAAAAAAAAAKA28NtPgbuuzf3vb1yJqrtRc
  gCDojeC1AQAAAAAAAABQGnhtojNm0O0riflRrBWWs0HQtwheGwAAAAAAAAAApYHXJjS1Q+2LsvdZ
  aBfgdDYI+nbBawMAAAAAAAAAoDTw2sTlRnPBn6QYr0F4x1OAIOhdwWsDAAAAAAAAAKA08NpEZFQ/
  vvnFlR/EWmLfKAR9guC1AQAAAAAAAABQGnhtwtE22rs4d7+FBtcgQNAnCl4bAAAAAAAAAAClgdcm
  Fk+6K//THX/cNwpBMxG8NgAAAAAAAAAASgOvTSBiGnJ/O9ER+0YhaIaC1wYAAAAAAAAAQGngtQmB
  ftKwryT6hzGW01eOvuMgQBD0MYLXBgAAAAAAAABAaeC1KU/P+KBrftDUcjbtQql3AEHQxwteGwAA
  AAAAAAAApYHXpjB1wx3/J3OrxfUvLaJhtEHQ5wleGwAAAAAAAMAsmZycnNBPcJZer2fFg18EXpuS
  lPY3/uWdAFw5CkGzI3ht4NMxGAw65WBBAAAAAAAA8HnU1tYePHR4z959e/ft56Ndu/dEnjpN02kW
  AXgLeG2Kkdf1+l/e9ILRBkGzJnht4NNJTEravmPn7j17OYumJjQZamtrY3EAAAAAAADwGbx8WWy/
  ZKmllY2VtS0ffbXI0j9gNZa2vRd4bcqQ0lz420lOMNogaDYFrw18Ip2dXb5+KxZbWlvb2PEXlRsX
  n8BCAQAAAAAA4DN49arEydnVzt7BfslSPqIJbeDadfDa3gu8NgW4Upf5K3E2uHIUgmZZ8NrAJ3Lv
  /n1LKxvJpIGbaHayfv3GwcEhFg0AAAAAAAAzBV6bUMBr483Jipvfj1lkoZ0vtQkgCPpMwWsDn8Lk
  5OSOnbtoiiCZNPCUja3948dPWEAAAAAAAADMFHhtQgGvjSeTx18nfRG9CCvaIEgWwWsDn0JJydR0
  xNZuiWTSwFNW1rbHjp9gAQEAAAAAADBT4LUJBbw2fhwvT/qe9iuL6IVSgwCCoFkRvDbwKZw9d17B
  DaRG2dot8fBcVldfz2ICAAAAAADfhk6n6+3p7enpYf8NpoHXJhTw2jhx7HXi97QLsaINgmQUvDbw
  0XR3d3v7+Cm7qM2oxVY2cXHxLCwAAAAAAPA+RkdHq6qqMzMfXLl67cDBQ56eyyJPnZ6cnGT/N4DX
  Jhjw2nhwuCz++zGLsaINguQVvDbw0dy+nWpjay+ZLigiCiMwcN3IyAiLDAAAAAAAfP314OBgTU1t
  fn6BNjrmwMHDy1esdHXzsLN3WGxpbWVtu2ixFbw2CfDahAJem+wcKI39rnYhjDYIkl3w2sDHMTo6
  um3HTpqlSaYLisg4H8p9+JAFBwAAAABgfhgMhqGhoZaWlsLHT6KjYw4dPhK4dr27uydN2BZb2dCv
  Nrb2tnZL3hhJllY28NokwGsTCnht8nKiPOk72gXYOgpBPASvDXwcNBGRTBSUlaWV7ZEjxzBNAQAA
  AIBZMTGh72jvfPzkSXx8QnDIyQ0bNzs6u1rb2lvb2Fla2dCvHzjuA17bu8BrEwp4bTJyvubeD2Ot
  sKINgjgJXhv4OCIiTwmyqM0omhI5u7jV44YEAAAAAKiaiYmJ1rbWFy9e3E5NC4+MXL9ho7uH11JH
  Z5qYWVrZ2Njaf7xPBK/tXeC1CQW8NrmIb3z041gri6ndo+84AhAEySF4beAjaGtr8/FdLshhbW9E
  U8yr166zEAEAAAAA1EJPT295eXla2t2w8IhNm7f6+q1Y4rDUeOaaZFvoJwle27vAaxMKeG2ykNZa
  9Gvx9haa+VIvAIIg+QSvDXwEt27fFmpRm1E0UwlYHdjX18eiBAAAAAAwfUZHR/fuO0BTL5rq0K9G
  f21WzCB4be8Cr00o4LXNPvld5b+X5GKhhdEGQXwFrw18GzrdxOYt22haIJkoiCCaeubm4oYEAAAA
  AKiHjs5Ov+Ur5dhPAK/tXeC1CQW8tlnmVV/9v0jxstDMk7oAEATJLXht4NsoKnrmsNSJ5xTk42Vl
  bXfg4CEWKAAAAACA6VNfX+/o5CLH1Ate27vAaxMKeG2zSdNI13+6E0AJv9QCgCCIg+C1gW8jLCxC
  wA2kRtnaLXFxda+orGSxAgAAAACYOM+ePZdp6gWv7V3gtQkFvLZZY0Q/tjB7r4VmrjT/hyCIj+C1
  gQ/S1tbm6bXsA5fHKy6ajF65eo2FCwAAAABg4qSm3ZHp7A54be8Cr00o4LXNGquKzmBFGwQpKXht
  4IMkJSfTtEwyRRBKtnZLVq707+vFDQkAAAAAUAOXLl2G18YNeG1CAa9tdgguv/Ed7XwL7UJp8g9B
  EDfBawPfzNjo2MZNW2Sa7c2iKML09AwWNAAAAACAKXPo0BF4bdyA1yYU8NpmgeSmgh/FWltoF0gz
  fwiCeApeG/hmioqKlixZynPyMTNZWdvu2bvfYDCwuAEAAAAATJPJyckNGzfBa+MGvDahgNf2uRT1
  VP1OkjOMNghSXvDawDcTGnpS8A2kRtH0yMnJpby8gsUNAAAAAGCadHf3rFwVYGNrL5ntzIrgtb0L
  vDahgNf2WbSN9v5Fmj+OaYMgIQSvDXwDzc0tHp5C34rwtmjueP7CRRY6AAAAAIBpUl1d7eHpJdME
  DF7bu8BrEwp4bTNHP2lwKQiC0cZFC6dWDmrmW2jmWUTNnWrzqC8trv/j1G+08+kvfBFj+UuxVj+M
  s/5JvB1ktvpxzOKUpkL2fALwFnHxCTLtX5BDNrb2fstX9vb2sugBAAAAAEyQx0+eLHFwlMn6gdf2
  LvDahAJe28wJLr+BraNySbuQ2WqaKX0RY/lbSc5/ctP7r+8GLs7dv/zpqV2vNEHlyedq7sY05Ka2
  Ps3qePWoq+xpT1X5QFP5QDNkrmoanBhlzycAP2doaGjDBrnOCpFDNEOysbW/d+8+qwAAAAAAgAly
  9+49+U7wgNf2LvDahAJe2wzJ6Sz9tXj7qfVWEpMImpmmlq3Nm1qtNrVUbeFvJTn/7b1Am4eHthdf
  u1734FFnWfVga+/4kH4S54UDAD6Nx4+f2Niaxu7RN7Kysdu5a8/4+DirAwAAAACAqXHt+nUra1vJ
  JGe2BK/tXeC1CQW8tpnQNtr771JXTHlDEsMI+jQZF6/NsdDM/XGc7X9IW+WUf/xoWUJm+8umka5x
  wwRrbgAA+AyOHT9haSXXPE8m0SRpiYNjSUkpqwMAAAAAgEkxOTl5IihYvo0F8NreBV6bUMBr+2R0
  Bv2SR0dxTNtnSTPPQjP3+7FW/zZ1uWtB0MWa+yX99aN6rOAAAMwyDfUNnl4mcyvC27Kytj116gyr
  BgAAAACASaHT6TZt3iLTJaQkeG3vAq9NKOC1fTLHXyd+JxrHtH26tAuM1xr8ON72v6Vv2l8SXdBd
  PqAbYc0KAAAyEBefIN9BIbKK5qa+fiva29tZTQAAAAAATIfBwSGvZT7yfd8Jr+1d4LUJBby2T6Ow
  u+JX4+1wTNuniG0U/Um83ZysnSEVN0r7G3DsGgCAA6Ojo2sC18n3harcoklkauodVhkAAAAAANOh
  vr7exdVdPt8HXtu7wGsTCnhtn0C/bvjv72+YWpwltZOg92nqLtG534te9Jd31+wtiS7uq2PtCAAA
  XHj0KI8mATwnHLMrmr5s3bod0xcAAAAAmByPHz9ZutQJXhtP4LUJBby2T2Bb8TXch/BRml7I9ltJ
  Th6FIeltL4b1Y6wFAQCAFwaD4djxE/LdfsVBNFVa6uj8/MULViUAAAAAABPh1q3bsh6YC6/tXeC1
  CQW8to/lQUfxj2KtptZqSXwl6G1p5lpo5//5bb8DpTE1Q22s7QAAgDsNDQ3OLm6mu6jNKJpHRkSe
  YlUCAAAAADARLl68JOtXnvDa3gVem1DAa/souscH/uKOP3aPfkiaed+N/uq/p2/S1Gf364ZZwwEA
  gEJERWlMelGbUbZ2Szy9vNvbO1itAAAAAABMgeMnguC1cQZem1DAa/soAp+ft4iaI3WXoClNHcpG
  v/6vjK2JTXmjeh1rMgAAUI7+/oHAtevp418yITBFUS2SkpJZxQAAAAAAhGdkZGTb9p2yzsTgtb0L
  vDahgNf27aS1Fv0wxhK7R98jzTwL7YJ/fLDjdsuTiUk8YAAAUXj0KM90rx+VyMrabtPmLcPDWC8M
  AAAAANOgq6trxUp/nNfGGXhtQgGv7Vvo0w3/5Z3VuBJBKu0CC+38v767OqYhRz9pYI0FAABicOjQ
  ERVsIH0jmqo+e44bEgAAAABgGjQ2Ni11dJbV9IHX9i7w2oQCXtu3cKA0dnqP5Dtmk9lKu9Aias6f
  3PQKr7zVPzHCmgkAAIShurrGzd1D1q9SOcvK2jYk9CSrHgAAAACA2Lx48VLWDaQkeG3vAq9NKOC1
  fYjS/oafJjhYaBZI/SazlWbuj+JsVhedbR7pZm0EAACCcf26Gm5FeFs2tku8lnk3NTWxGgIAAAAA
  CMydO3fhtfEHXptQwGv7RnSGCavcA7gSgUm70EK74P9mbnvYWcoaCAAAxGNgYGCVf4BqDmt7Iytr
  W9yQAAAAAACT4MqVq/Da+AOvTSjgtX0j2oac70bjPoRpRc353SSn0IoUXDMKABCcrKxs9RltJKrU
  uvUbR0dHWT0BAAAAAETl8JFj8Nr48+pViaOTi63dEjt7Bz6ysrZdEwiv7f3Aa3s/HWP9/+q2r4V2
  vtR1MjdN34EwL2t3aX8DaxoAABAVg8Gw/8BBlW0gNYpmM/Rrfn4BqyoAAAAAgJBMTk5u2rzFyhpe
  G29evXq11NHFxnaJrZ0DH1la2a5eA6/t/cBrez9bXl7F7lGLqLm/meAQXJ48oh9n7QIAAAJTVVXF
  eeU8T1lZ2x4/HsSqCgAAAAAgJD09Pf4Ba+TeZwCv7V16e3tzcnIyMx88eJDFRxkZmYWFjw0GA4sA
  vAW8tvfweqDxNxIcppZ0SbwnM9JCi6i5//X++qc9VaxRAABAeK5cuUYTL8lUTDWytVvi6ubR2NjI
  agsAAAAAIB61tbWeXt5y3wgPrw0IDrw2KZNfT7oVhpj1ojbtgu9FL1xVdLpXN8QaBQAAhKe/v3/l
  KhXeivC2aFoZHR3DKgwAAAAAIB5FRc9o0iL3PgN4bUBw4LVJedhZ9qM4m6mFXRIHykykmfezxKWX
  a9Mnv8ZrCwBgSmRkZhrPgpVMxdQk42VPw8P4IgQAAAAAgnL/fjqHfQbw2oDgwGv7BSYM+rnZuy00
  86QOlJkoas5/Sgt4gn2jAABTQ6fT7dt/QJW3Irwtu+krn/Ly8lm1AQAAAAAEI0qj5TAlg9cGBAde
  2y+Q1JT/3WhzPaYtau6inH2toz2sLQAAwHSoqKh0dHJR96I2o2jyeuTIMcwsAQAAACAmwSGh1jby
  XkJKgtcGBAde2z8xoh//u/vrLDRzpSaU6qVd8B3twoCis8P6MdYWAABgUpw7f4H/ojZFrD0q1MXV
  vba2jtUcAAAAAEAY9Hr95i1bOZyfC68NCA68tn/iQs19c9w9qp3//ZjFIRU3WCsAAICp0dXVtXKl
  P89bEezsHZY6OoeHR3p4LpP7mq13ZW1jdz0qilUeAAAAAEAYhoeHvX38OMyO4LUBwYHXxujXDf/F
  nQCz89q0C34lzvZaXSZrBQAAMEEyMjI4L2qzsbX3D1g9MDCwa/ce/uvpqPSA1Wv6+vpY/QEAAAAA
  xKCxsdHN3ZPD2n94bUBw4LUxLtemf0drZie1aeb9VqLjjeYC1gQAAGCC0Bxrx87dnA0vmt5po6Op
  9IzMTP5eG8nK2i47O8fYAgAAAAAAgvDkadFSR2d4bQDAa5tiRD/2V3fXWGjmS90oFUsz7/eTXXM6
  SlgTAACAaVJSUurs7MpzIyeV5e7hWV1TQ6V3dXWt4Lt91Sgra9t9+w8aWwAAAAAAQBBS09Lspq5N
  l05dZl3w2oDgwGub4nr9A/My2rTz/yDZ9VHXa1Z/AAAwWc5fuESTLcn0S1ZZWdseOnSEFU8BKHEt
  g63dEhdX98rKShYEAAAAAIAAXLly1dKKx7wIXhsQHHhtX48ZJv7r/Q1mdP3o1Io2t9zOUlZ/YDoY
  JieH9WPjhgnom0RNxBoLmAfd3d3ePr6cbyewsbXPLyhkEXz9dWVllaOTC4e9EhLRFPPq1WssCAAA
  AAAAAQgODuHzHSS8NiA48Nq+jm98ZEYntWnn/36ya16nGla0GQyGsbHxoaGh/v7+np6e9o6O5uaW
  puZmEv2mra2dkvC+vv6BwcHR0VG9Xs/+mSkzptdtfH7pP9/x/5t7a6F39dd3/B+0F7PGAubB7dRU
  zvs3rW3sAtduGOgfYBF8/fXExMT+AwcVWdq2YqV//8A/RQIAAAAAoCCUdu3YuZsmS5JJixyC1wYE
  x9y9tlH9+H/P2Gwu149qF/x2klNWxytWeZNibGyss7Ortrbu2fMXmQ+yb6Tcjo1LvHpde+7C5VOn
  z4VFnD4Zfkoi+sOIU2fPnLt4+WqUNiYuKTnl7r30wsdPKyqrWlvbhoaGTfHVXD/cMXW24PX/NzVo
  IYmu/d/4hkespYAZQK+Fnbt434pA00etNoZF8HMePMiytVvCeWkbFUeFpqdnsCAAAAAAABSlp6dn
  5aoAPhsO4LUBwTF3r+1u67MvYhZJPSlVSjv/J3HWyaZz6yi9NwcHh6pravMLCm/cvH3latSpM+dD
  TkYEh4YbRb8nhYZFSiw2iegvkN7+h6TwyDMXL12NS0jKys4tK3vd3dMzMWEyC99qhtr+7W2/KWtJ
  0sVQ1JzExjzWTMAMKCkptXeYspwkcy/5RGW5uXs2NTWzCH7O4OCgf8BqRW5I2LN3v06nY3EAAMCM
  oEmXXq+nl8n4+PjoNCNvmP7PsbEx+n/p7yCtBZwxGCYNBsPExAQNThqHU4PzrfE5PTynxqdxiGJ8
  Kk5zczO3gzXgtQHBMXevze7RYfPwLBZ+P2bxxdr7rNoCQ5+jzc0teXkFCYk3zp67GBoWGRQSZnTW
  vtVW+3i9cd+MPzzy9DmNNjbzQVZVdc3Q0DALRWCe9lT/4Q0387rQ42MEr83MiIw8RdMsycRLVllZ
  2waHhL53Vnc9SsM5GBLNZR2WOlVU4IYEAMCH0Ov1vb299fX1JaVljx8/efAg6+at29ExsZcuXzl7
  9lx4RCS92Y4eO37g4KHde/Zu37Fr2/ad27bt2Lp1+9ZtO7Zt37F9x86du3bvP3Dw6NHjISEn6d17
  /sLFq9eux8bGpaamPXz4qLi4uK6urru7G9Y/+Hjow5QGDA2bmtra4uJXBYWFWVnZaWl3EpOSNBrt
  hQsXT50+ExYWToPz2PETBw8d3rf/AI3D7TQ4t+8wjk/6lf5zx85du3bvoaFLQzQoOOT0mbM0OOPj
  E+hHZWVnP3nytKysrK6+vr9/AKYMB14Wv+L21SO8NiA4Zu21lfU3/mrCEmm6rkIttNAuOFQax6ot
  JBMTE42NTQ+ycq5rosMjThvNNYlBJqtCwyKpUPrNhUtXU9PulldUDg8Lbbrda332a/F2FlrYbW8J
  Xps50dHR4ee3gudSMjt7hyUOjoWPH7MIfpHqmhoXV3fOtzSQrKxtz52/wIIAAJg3lHP29/fX1dU9
  e/bs3v10jTY6LDxi9+69/v6rl3n7unt4Obu4LXV0pleHtY3dYktrEiWrRtHLxMrajv78mzT9F2yN
  f3mxJYn+uQ29hOnF6OTsSj+civBbvnLrth1hYRFx8Qk5uQ9LSkqbm5tHRkdZfMAs0RsMPb29dfX1
  L4uLs7KyY2LjTp0+c+jwkY2btixfsWp6ZHq+GZk0oqYH2NToemtkTkkyIN8rS2vbxdP/nP7h9AzB
  0dHJxcXVjYrw9vHbsHFzcMjJ2Ni43NyHZWWvW1vbxsbGWJRglrh37z68NgCMmLXXtvnFFUrOpem6
  +hQ1x/dJpLD3M3Z2duXlF0RpY06GnwoK4W2xvSuj6UZhXLh09X56Zn19g7D3Klyve/BLU128UNrj
  Zit4bebE7dQ0mnlLZl2yiibx6zdsGhsbZxG8w8FDRziHRKIZ7YoVqzo7O1kQAABzgt5InV1dr16V
  pKTcjIg8tXPX7jWBaz08l9GbwWg3GB0K+k9buyXGYyWNkrxJPkfGH2j8+VQQiQqloikAh6VOPj5+
  9OY8duxEYmLSi5cv29s7YL2pG5o29/f3Nzc3P31alJCQGBQcsnXb9oDVa2hY0miRDMs3I9PWTq6R
  +WZwkpgfNz04lzo6+y1fuXHTZvrsjo2LLy0r6+vrE3bOb0JcvXqdGlnSFzIJXhsQHPP12tpHe/95
  ipf6lwVFzfnHBzuGJoSb1uh0E1XVNSk3UyNPnwsKCVPcYntXFBIFRr+Jjol/8bJYzL2lO4qvYyfp
  Pwlem9mg0+m2bN3ObTJnFE3pkpKSWQTv4+HDhzSVl/wrDqKk5f79dBYEAEDt0Auwpqb2/v37589f
  2LV7j6eXt42tPb0PjQ4X/YZeRLPrWcxYFMYb640Co9+7uXtu277zwoVLuQ8fdnd3syoBE8dgMPT0
  9BQVPYuNiz927PiawLVLHZ2tp4cldb3RWRNnWBolGZwU3sqVAceOByUl3ygvL5+YmGB1A5/I0WMn
  qD0lrS2TqO/gtQGRMV+v7Uz1HfWf1Kad/2e3/GqH2lmdxWB8fLyktCw6Nt54aNrb9paYoiBJFy9f
  zcsv7O8fYNUQgzG9zvbRYbNYnvkxgtdmNjx/8YLm8Txn7TQL9/Ra1tzSwiJ4H4ODg6vXBNLcXfJv
  5RZNanfs3EWpDotDpbx+XX75ytUrV69xFhUaHR0zipU4n01Wds7FS9Sc0haWVVTi/fvpKng6qAot
  ra2PHuWdv3Bp7boNLq7u9AJcbGlt9Agk7wSRRWFTzJQhL3Fw9Frms3//gaSk5PLySlgbn4lerx8a
  Gurs7GxsbKysrHr5sriw8PGDrKybN28nJCR1dMiy9rmvr+/Fi5f0hty1aw/1Jn0uG60r/p+DsyJ6
  lIy+m5Oz67r1G7XRMSWlpWraZNrW1nbtepTkJTm7op/vt3wlt5cSFbRu/Qa5K/XxunDxUlV1NWtu
  haAPixspN+nDVhKbfKLP2adPi+B4vhcz9drGDLr/cn+9yr027YJfj7fP7SxldRaA8XHdy+KS61HR
  wSeV3yv6qQqdvqXh3IXL2TkP+/v7WZUEoGOs76/urLbQzJUOADMUvDazITwikib0kimXrKLiTp4M
  Z8V/MzGxcZwDI1Hu6ujkUlz8igWhUurr6ymRM+4/4ikqkfo0OyeXxQFmxODg4MpV/l8tspQ0r9xa
  +JVldEwsC8IE0el09Q0NyTdSdu3e4+PjZzPtUtnY2vP8pkEmURUoT7aePjbOxdV967btCYlJ9JjD
  dHsD5a7j4+NDQ0O9vX0dHZ3NzS11dXUlJaX5+QX376cnJiVdvXotIiLy8JGj23fs2rRpy5rAdStW
  +i/z9nVz91i61NnaZmof8aLFVjRmHj56xH7oZ6PXG9rbOzIzHxw/EeTvv2aJg+Mbz1cFw9IoO3sa
  mVPHxtFn66bNW1NSbra1tavASnj1aurWArk/RjkPA6NDKojmL/gqIzNT2aGi1+sDVgcu/GqxJDb5
  RLW+cuUqvLb3YqZeW3rbi+9KsnTV6bvaBeGVt1iFlYYe+/LyiihtbHBoRLCpuWxvK+TnjltB4RNx
  Lk8o6qn+zQQHC+0CyRgwO8FrMw9oyuvp5c3tW1MSTRwpnXj+/DmL4JtpaGjw8FzGMzajaK5z+sxZ
  FoRKoWlcSEgofyuTZGlle/ToccwjP4fsnBz+qTiVSM9ja2sbC8J0oMHW2NiUmJi0Z+8+J2dXesBp
  5KvDYnuvqKeoglRNquze/Qfu3bs/ODjI2sJs6O7uzs7Ovn07NSY27uLFy+ERkUePndi7d//mLVtX
  rwn08Vnu7OJGY8D655cAWFlP7Rp+S1N/SH+BGlPyrC1abEU/8/PfYH19fQ8eZJ0ICqaPYGOhVKJa
  x6RRVLvppralKoeHR74uL2dtYZqUlJRy3hNgbqKX2IOsLGVnCxMTE+vXb6RxK4lNPlGtr1+Pwhzp
  vZip1+bzOFzl2+6ivnTKPzExKcQBny2trUnJKaayY/RjZKzLlatRpWWvBdmZcqoq9Tvw2uC1mQc3
  Um7SxFfySS+raMqyecu2j9xIcvx4EOfwSJRZeXv7dnZ1sSBUSmFhAVWWf55AJbq5ezY1NbI4wCei
  1+uPHD3O/7mgBCD0ZBgLwkQYGhp69Cjv6LHjrm4exiTfrBJjqixVmV5oK1cFxMbGNTU3s3YxAx7l
  5S1xcDS6adPXvNpYWjE/y+igzXgk0A85fvzEjE/9p4luRUXFxUuX/ZavoBjosbI1P7OG2p8q7ujk
  EhQU8upViYluS4fXJrfgtQEJ5ui1dY71/8ENdzWfKK+Z/x/SVnWM9bEKK8fQ8HBWdm7EqbPBoeES
  u0oFMp7jlpxyq7VN+RPxDJMGt4IQlTvI3yp4bWbA+Pj4ps1bec4hSFTcrdu3WQTfxuPHT2giy38u
  S9nUzVuirGWWidHR0XV8Z5BvRFPJuPh4Fgf4RBoaGo3ni0laVVYZi3taVMSCEBvKUhobG2NiYtcE
  rqOs3twstndlYzu1g89rmU94RGRtbS1rJlXz8NEj+yWyfHbQiFq1KmBoaIiV9NGMjIzk5eXv23/A
  2cVtsSUNSvXsEp2ZqPo0LJc6OoeEnqyvr2fNZDrAa5Nb8NqABHP02q7VZar5pDbtwp/E2T7oKGa1
  VY6qquqr1zRBIWGhYZESl0pNCg4Njzx9rqDw8bhOx2quEB1jff8xbZX6b/z4gOC1mQFFz54tcXDk
  OVOklM/Xb/nHHyw9PDy8YeNm/n4QJedbt20fHx9ncaiU+IQEmtVJ6s5B1KHUraMqOiSbJxpttJU1
  7yeCumzjps3in2tO+UltTe2p02fd3D1pbFPYyITfyOi4ubl7nD13XvVr3B49mlrXJkfv0890WOpU
  X9/ASvoI6MHJzs7Ztm0HdQF9uNia1P0bcsu4xs3dw/P69SihTnD+VuC1yS0aGPDawNuYndc2+fXk
  Vzn7LKLUe5B81JytL6+y2irEyMhIRmbWyem9lm/bUmrV1JbS0PC4hOS2doUXuN1re/6DGEsL7ULp
  qDATwWszA8LCI+hDXfIxL6uouMhTp1nxH0dcXDwlJ5KfI7do9kx5WnGx8l+0yEpDQ4O7hxf/xG86
  WXV89hFn9gEJQ0NDGzZu4u8+05ObkJjIghCV8vLy0JPhzi5usDM+IGoZah8Pz2VRUZreXuU3bciE
  rF4btWFWVjYr6YMYDIYnT55u3bZ9utl5P7YmJGofS2vbDRs3v3z5krWd8MBrk1vw2oAEs/PaSvsb
  fy3BXrWnyEfN/bt76wcnRlhtlaC5uSVKGxMUGm4mRtsbBYdGnDpz/sXLYmXfNYHPzpvvnaTw2tRO
  a2ubpxfXmweMBhZNT1kEH0dLS6ubuyf/6SxNd8IjTrEg1MvxEwqciEeagesKiKdPi2xs7SWNKbfo
  LeHu4UUTEhaEeDQ2NdFwcnaZuvcAqe/HaMrasLJds2btw4eP9HqTPC3rw8jntZFomF26fPlbJ6h1
  dXUngkIoDKyv/EhRQzk5u16P0oyMKJl8fSTw2uQWPWjw2sDbmJ3XdrA0VrWL2rQLfzXeNq9LsSty
  DAZD0bMXkafPBYeq5A6ET5XxBLe0u/cUvKK0Z3zwP98JMNOdpPDa1E58QgLn1TFW1rY7d+3WffoO
  8bAw3uvvSJSLLvP2bRPgBElZyS8opFSBf7ZAzevt49el9gsoZp1gJW6PpacvOOQki0Awurt7KDP3
  8FxGQfL85kAdmvaAloaEnGxpaWUNqhbk9tr27T/wgRP9dbqJlJSb7h5TwxJezCdp2gW2OXDgkPhX
  HsNrk1s0EuC1gbcxL69tzKD7m3trVXsrQtTczS+vsKpyZ2xs7H56ZsjJCHNbzvaugkLDtdFxnZ2K
  5WP3Ws11Jym8NlUzNDS0cRPvc9BsbO1T0+6wCD6FJ0+fKjKjpfa5kXKTBaFShoeHA9eu479UinqT
  cqrbqWksDvARtLa2evv4ce4s43NX+PgxC0IYDAZDTk7uKv/VVta2NrZw2WYo6l9LK1sf3+W5uY9Y
  y6oCWb02egb9/dd0dXWzwn6R5ubmQ4eP0McHzN8Zy9LKxj9gzevXiq14+BjgtckteG1Agnl5bQXd
  5V/ELJbm5+qQZt6/T13ZPT7AqsqXvr6++ITkoJAwietktgoODT9/4XJVdQ1rIO74PomwMMM7SeG1
  qZqnT4s4pwFUHKVzPT09LIJPgeY6Gzdt4ewMkqjETZu3msRmls8hLj5BkW2kVOiu3XtVfwHFLHLz
  1m3+PWVja79u/UbRbkVobm4JCg61X+LA/7WgSlEvL3FwvHL1mmped7J6bfRj6YdXVVWzwn4OpccP
  HmT5+Pop8kZVmejR9lzm/eTpU9a44gGvTW7BawMSzMtr2/UqyiLqS2l+rgYt/CL6q8QmZVyG1ra2
  K9P3jUr8JjNXyMmI8MgzL1++Ys3El8bhzj+84aHacwm/SfDaVA3/U7po9nDx4iVW/Kdz6/Zt+gmS
  n8lBNI1++rSIBaFS6usbPL28+S/BoLZ1WOpUXlHB4gAfRKfTbd22nb+1ZGllm5R8gwUhAHq9/n56
  urevH70QkOXOougNQKNr9559TU1quKJUVq+NtNjSOvNBFitsGkqNExKSqFD+y4TVKhqQTs6uuQ8F
  XXEJr01uwWsDEszIa9NP6v8+fYM6j42PmmP78JB+UoGTYuvrG89fuBxy0kwPaPuwjNtpCx8/VeTt
  c7Liptmd2gavTb00NDR48fVWqCxnF7eysjIWwafT2trq47ucfw5jZW0bHBLKglAvR48dV2QhBs0p
  z3+GA2tWFBe/ktU7eK/oifNa5tPY2MiCUJr+/oHIyNMUFewMmUSP5IqV/mWvX7MWN1nk9tqm3l0X
  Lr6Zker1+itXrlFx/L+0ULfoSXdydi0sFG4POwGvTW7BawMSzMhrK+6r+3GcrQoPsdIu/LUE+5K+
  elZPjtTU1J46cx5G2wcUGhZJ7ZOT+4j/C2hYP/YP6ZvM605SeG3qJSExmT7LJZ/usoqmKbt272XF
  z5Sw8Aj+fhAlTp5e3upY6PEBCh8/VsS8oIHhHxDY29vL4gDfzOnTZ/mPfyrxRFAwi0BpyssrNm3a
  QiEhuZVV1MLePr6Pn4i7d+9jkNtro3fXtu07jdPRsbGx8IhIejoxMuUQfTa5uXs8f/7c2LPiAK9N
  bsFrAxLMyGsLrUihVFyanKtAUXMCis6ySnKkqrrm9NnzuAnhY2S02wwG3u+gtNai70Uvkg4YFQte
  m0oZHR0NXLues7FiZW33ICubRTBTSkpKJD+Wj2jek5CYxIJQKQMDA+v4zibfiIZibm4uiwN8A11d
  XX7LV/L3Q6nEp0XPWBDKQZ/3GRmZbu6e/N1G8xS9Clxc3anNWQeYIHJ7bfRo0CPZ29s7Ojp29Nhx
  +piA5yKfaED6+C6vq6tjvSsG8NrkFrw2IMFcvDbD5OQ/PthhEaW6NT6a+b9/w61uqJ3VkxfV1TWR
  p8/BaPt4BZ+MyM55yPk1pJ80LMrZb0Y7SeG1qZS8PHkzkHdFcxT/gDXd3TO5FeFtKKXZsWMXfz/I
  2sZ+3foNop0NP+totdGKGBlU6KHDR1kQ4BtIz8ig+bek6eQWPWsbNm4eHBxkQSiEXq+PjYunePhb
  jeYsau0lDk4PfvFIMhNCbq/NeDDCixcvz5w9h7WWHEQvwC1bt/f19bEOFgB4bXILXhuQYC5eW8VA
  828kOKjwqPiouYfL4lkledHY2HQaW0c/XdRiefkFU192cyS/+/XU1ulo1W2dfq/gtakRg2HyRFAw
  Z0uFirt48TKL4PO4fTuVMkDOU1sqjnI2Mc+LmUUaGhpcXN35pw2Usrp7eNXXN7A4wPvYs2ff1LqZ
  d1pPVlF2ERsbxyJQiJHRkdOnz/J/6iESNTu9Ex7lmeRMQG6vzajAtevgtnDTYiubyMjTBoMCB2q/
  F3htcgteG5BgLl7b+eq7Klzdo13wp7d8usYHWCW50NbefuHSFRhtM1NoWOSzZy9YU3LBMDnpXhii
  zt3T7wpemxppaGx0cXXjOTWkshydXKpralgEn0dPT4+v33L+h09bWtkGBYWIM8WXA6od/9tpjaJZ
  bHRMLIsDvEN5RYWrmwfnYU9PrpubR3OzkicVDg0NHTsRRIkHslmlZGNr7+7h+fSp6Z3dxsdro/aR
  /Akkn6g3SVlZOayPlQZem9yC1wYkmIvXZvfoiAoPidfMP/6a64k8/f39V65pYLTNWKFhkWERp8sr
  KlmDcqG4r+5X4u1UuKjzXcFrUyMarZb/orZDh4/QZIVF8NlcuHCJJiKSUuQWTaZd3NzFuY1RJvLy
  842VfbvuHESz2HXrNyq+V1FYaNrNf8xTiSGhJxWc7g8PDx89enzRYmtJYBBn0ePptcynqqqadYyJ
  wMdrgziL5i++vstbWlpYNysKvDa5Ba8NSDALr61XN/QnN73V5jVo5//JLe+OUX6nAIyNjcUnJgeF
  hEn8I+iTFBIWeebcxeZmrh+6rgXBZrG0DV6b6hgcHFy7bj3PGQPNQUlZn30rwtuUlpY5OrnwX9pG
  7aaNjmFBqJSRkZHAwHWKrNSgDi0qKmJxgLcYGhr2D1jDf1Eb/argvml6WR05cpS/wwi9V1bWtps2
  bTGt+4LhtalV9Fo4ERSsF2CZObw2uQWvDUgwC68tv6v8ezGLpWm5qStqzoFSfhtYDAbD/YwHwaHh
  EucImoFCTkZeuRrV389v8y89Aj+MtZIOIfUJXpvqyMvPt7FbwnNeaGNrH7B6zfDwMItgNqD5x67d
  e/hvdaSZVuDa9TxfNYoQExuniMFhaWUbEnKSBQHeIjs7l55Zzukcjfa16zaMjipzH8j4+Pjx6a2j
  kqggBUWv3KDgEJ1OxzpJeOC1qVXG92F+QQHraeWA1ya34LUBCWbhtR17nai2RT2a+X9ww7119HPv
  yPt4nj9/GXoSt47OmoJCwm6k3JrFTWofZvLrSauHB9V/ISm8NtVx6PBRzhYVzRjkOIcrIyPTyprf
  vOeNbGztp65kUTV1dXXuHl78lw1S2/oIszNIHAwGw5GjxyyteDvL9OQmJCSyIPhCVT5z5uxiS2wd
  FUt29g708REXn2AqGSC8NhXL2sZu27Yd42PjrLMVAl6b3ILXBiSYhdf2Vc4+tXltUXM2vLjEqic/
  TU0tkafPhYbBa5tNBYeGP8rjlwNntL/8fqyldCCpTPDa1EVtbZ2buydPD4XKohJra2tZBLNHT0/P
  ipWr+G91pFTz8OGjLAj1cuTIMf7LBkk0v0y7c5cFAaZpbGxydfPgnMtNP7keSp1OqI2OoUcb6auA
  ooHh7OJWUlrKukps4LWpWNStNnZLMjMfsM5WCHhtcgteG5Cgfq+tZ3zgD1I8LLTzpWm5KevHcbYv
  ++pYDWVmeHjkuiYau0dnXcZ7Emrr6llDy8y4Qfff0jepfGkbvDZ1EaVR4FaEI0ePseJnm0uXLvP3
  g4zuYVW1iZ0R/qlQjsrfxyRNLVXYvkPdl71+KrFKbOmlJ+v4iSAWAV8yMh/AHxFZNDY2b9k2MGAC
  W+nhtalb9HmxYeNmZW/Ugdcmt+C1AQnq99oy2l9+L3qRRfRCaVpuutLMs8w9wG1AZ2Rm4T4EmRQc
  Gn7lWtTsngz1AS7U3IPXBkwFSo38A1ZzNlBs7JbkFxSyCGabyqoqZxc3/nNcmgNptNEsCJVC2csa
  JW5IsLV3cHJ2ffWqhMVh9oyNjq3fsInnFJ9EzxSpQLYn9wO8fv3a3cNLEZ8X+njRO/Dq1evi54Hw
  2lQvGoppaXcUHIrw2uQWvDYgQf1e296SaIuoL6U5uSnre9GLbrU8YdWTmaqq6pPYOiqngkLC7qdn
  Ggw8Xk9dYwN/fNNLZWs8f0Hw2lRETk4ub6PN1n7tug3yfedsMBj2HzjEf2kb1WuV/2qTWNbxOWi1
  MfzblkRTzAsX+R3pIDhFRUXUJpwTORrhgWvXjYyMsCB40dvbu37DJkVGHfRJMu4kfV1eznpOVOC1
  qV7W01e4DA0NsS7nDrw2uQWvDUhQv9c2L3uPhWauNCc3XWnm/ae7q4cmRln15IRmrlevaUJORkjs
  IWjWVVVdwxpdZtY9v6Ay6/kXBK9NLdAH9oGDvG0pKi42No5FIA/ZOTk2SpzrRKmm4sfEyE1tba27
  B9fT/YyiEpev9O/t7WVxmDdh4RH8b0WgJzc+PoFFwJGwsHAYbaYiKxu7gwcPCX4nKbw21Ys6lz4y
  8pW7sAhem9yC1wYkqNxr6xkf/Fe3fFW1kCdqzr4STruBcnIfBeGYNvkVcjLiWpR2dJSHf/qkp+r7
  sVbSQaUawWtTC1XV1S6ubjx9EyrLw3NZc3Mzi0AeBgYGV69Zy3mHHcnK2vbAwUN6vZ7FoVKOHD2u
  iPdBHZqhdivzY2jv6PBa5sPZ7qTiPL2WNTQ0sCB4kZGRSUUjZTUVUU/Z2NpTDsz6T0jgtZmD6EMq
  KChEKVcCXpvcgtcGJKjca3vWW/PDWGv1HNamXfCTeLuSfh6n6Te3tEacOou7R/koKCTsUV4+a3o5
  0Rkm/mHqhgSVbiOF16YWrl27Tp/cks9yWUXT3+CQUFa8nNB0hHPVSDSxdnRyqayqYkGolPz8Ahtb
  BeyPKSvzwCEWhBmTcvOWDfeTy6jxjx07wSLgRVNTs4+vH//Kyi16dmztlrwRVZAeqDf/Sf+vSafo
  lHkGBq7r6+tjvSge8NrMQfQouXt4tba2sl7nC7w2uQWvDUhQudd2ve6BqmyFqLn/78F2g/xD2WAw
  JN24ibtHuSk0LPL0mfNd3T2sA+Tk+OskVe2qflvw2lTB4ODgKn+utyIY551PnxaxCOSktrZOqRsS
  Ll2+woJQKf39/ZRL8182SLmTq5tHTW0ti8MsGRsb27FjF//Gt7GxKyx8zILggl6vP3bsOH/H/PNF
  rx0aq/RqtbYh2VlZ21ItSIstSdb05w5Lnd3cPD29vJd5+3r7+Pn4+tGv9Hsvbx8Pz2X04qIfMv33
  rY3/kH4C/RwS/VujGfd2cQKKYr59O03YhBBem5mIHpmk5BuKjEN4bXKLXjLw2sDbqNxrW110Tl2H
  tc09W32H1U1OKquqsaKNs4JCwu7cvc/hNVUx2PIbiUsttCq6mfeN4LWpgszMB5T08ZwL0oxk06Yt
  o6NjLAI5MRgmFdnqSMnwylWre9R+rFhUlIZ/25IWW1pHR8ewIMyS0rIySZtwED25lFFwvvcjKyub
  niZTSVYpTlu7JUZbbYmDo5u7p7ePX0DAmj179p06fSYuLj4t7U52ds6TJ0+Li1+Vl5fX1tY2NDQ2
  NTU1Ey0t9Av9nv67vr6hqqq6tLT02fPnjx7l3bt//8aNlMuXrxw+cnTtuvU+vsvpJ9PPNxpwwvpu
  NGBWr1kr7EUx8NrMRDQOt27dzv86FwJem9yC1wYkqNlr008a/u+D7RaaedKE3FS18NcTHGqH2lj1
  ZEOn00XHxuNKBM4KDYsMjzxD81vWDbJhmDQsUNmFIW8Er830oSnC/gMHOdslVFxSUjKLQH4ePnxE
  hXKe7FJxNrb2GRmZLAiVUldXr8iyQWrbwMC1fI7dFJMzZ87ydzmpRM4WZ19f3xoljlz8VFGEltOe
  l8NSp5WrAo4dPxEbF/8oL7+8oqKrq2t2j26k/Kq3t7eysjI/vyA+PuHI0WO+fsunY7A3+m5vB6as
  6M1gZW2Xmiro0jZ4beYj6uWysjLW8RyB1ya34LUBCWr22rrGB37/hpt61u9o5n2ZtVM/aWDVk43S
  stcw2hRRcGj4jZRbHF5Vp6pSLaLmSAeYCgSvzfSpqqriPBGkVNDDcxnPw1OGh4fXBK614X7YE028
  9uzdr+4bEqh2lOrzN31oxDosdSooKGRxmBnd3d0rVwVwHtLU5i6u7o2NTSwILlA6YWUtqNFGDTJl
  sVnZ0Dtt9ZrAsLCI9PSM2tq6wcEhnk89lTUwMFBaVpqYmLT/wCFXNw8KiQITJL23trEPDFxHL2EW
  rkjAa7ObHsYSSf6OOkQPRXRMLH9vAl6b3ILXBiSo2Wsr6C7/ImaxNBs3XWnmBZensLrJhk6n00TH
  4qQ2BdUo/9K21/1NvxJvb6FdIB1jpi54babP+fMXORslltY24RERrHhexMfH09REEoncoum1o5NL
  WdlrFoRKycnNNVb27bpzEHVoSOhJ85xrZj7IUmRR24mgEINB9i8g31BbV+fq5iHUQi2jbO0caPhR
  Cr123fqLly4/f/FCkBsAKOWrr69PSEzatHkLhcd/kLxXNrb2Wdk5LESRUL3XRlUzirrA+hdODLRe
  tNiKfkN/SP8XPWI/l73xb9JfMJ4SSP+ERH9C/6/xR0mKMBVRLXbt2qOI1+aw1OlN6826JNXkJkkY
  CooGKrw28DZq9tou1txX0wbSn8TbFffVsbrJxuvyCpzUpqCCQsNvyX9wr37S8A/pG1W4jRRem4nT
  1dW9ciXX1TE0MaIM8Pnz5ywCXjQ0NHh6edN8VxKP3KL5/bnzF1gQKmV4eDhgdSDPUWQUjSUPz2Vt
  bbKf8yAek3v37aehJWkQWUWtbW/vkMfl/u43hIVHUEYhiURZ0TinlndxdQ8KDikqeqbT6VisgkGB
  vXj58vDhoxQz56HyriiAffsPUDrKghMG9XltVBcaovTUkIzvZPrAdffwWr9h4569+44eOxEREXnx
  4iVtdExKys179+5nZj7IysrOzsnJyc2l/2VnZ9N/ZmRk3r6dGhcXf+XK1chTp4+fCKIXzprAdTTs
  p5ZoUYdOm3H83/mfI4rW28evubmF9T0vsK5NbtFQh9cG3kbNXtuWl1ctor6UZuMmKs28v0/foDPI
  uwtAr9fHxiViA6mCMp7a1tbWzrpENvaWRKtwGym8NhPnAffVMTQX2bJlmyJJ1/HjQfxzTprfL1+x
  srOziwWhUrTa6MWWCngiNJySkm+wIMyGqqpq/qu9aCRTss3zcPHKykrK7fn7498kagFKb5avWHX5
  8tWGhgae6/tmDL1pnz4t2r1nHzWjgs6I3fRXLBUVFSwsYVCH10adS29C+nSztJr6gFu9Zu2hw0dO
  nzlL78b8/Pyamtq+vv7R0VGdTjezrc001HW6CXr2u7u7S8vKMjIyozTaoKCQdes2UOvRQ0FF0+gS
  vxmplfLzC1iteNHf3//wUV7uw0dy6FFefkJiEucjU6kZd+/Zm5dfIAlGKWXn5La3y57EfRh4bUKh
  Zq/N7tFh9bgJUV9ufnGFVUw2GhoasahNcQWFhGU8yGJdIhuPOl9/L2aRdJiZuuC1mTi7du/hfBYS
  TcpT03hc7vwuT54+VSTbpCrfvXuPBaFSqqur3T0U2OtHbbtt246xMR4X2orDtWtRVHFJU8gtmtnH
  xsWzCLgQHBxKhUrCUESUx1Iknp7LKLfpMkHffGJCl5GZ6e3jZ63cyXfUgOfOXxAtMzRpr43CNvq/
  rm4egWvXBQWHpKXdqais7O3t5WAEU1cODAxUVVXfuXP3+ImglasCKB56L4ncmIstrS9evKQye6K2
  ttbdw4vnhy8NuVOnTsPleRt4bUKhWq/NMGn4q7trVLOH9LvaBSnNsh+6fOfu/aCQMIn1A3FWaFjk
  uQuXBwYGWa/IQ8/44B/f9FLbkW3w2kyZ0tIyJ2c3nlM0Sgz8lq/s6OhgEfBlaGho46YtPCdDRllZ
  2+3YscskVsF8DocOH+FvAFFeR6nyq5ISFoQZQPltwOo1nF1jeku4uXvW1dezIOSnoqJCkEVt1NQ0
  xoKCQ+vq+FVfDhobG/fu229trcydCfRuWLUqgEYvi0YMTNRrozFJL1uHpU4bN22Oj0+oqKhU/PsG
  6tlHeXnHjp+gx5Y+ZDm/oD5SFNXadeuF3fc9M6praujlzNlri4TX9ovAaxMK1XptHWN9v5fsaqGd
  L83GTVHaBb+V5Nw80s3qJg99fX1nzl3AujYRFBwaXvRM9gOkrB4eVNuRbfDaTJmLly7Tp7Xk81tW
  GadorHgloLSEv9dmazd1Q4Lq/aCHDx/x99pINKjOnj3HgjAD8vLy+eex1LNHjh5jEXDh3PkLnN9O
  78pu+tRt/4A1hY8fq8MrHx8fu3Llqo3t1DHtksrKLSqRlMd9B9+HMTmvjT6/6LkIWL3m0qXLpaWl
  otlGlPk3NTfHxMYtX7lq8fT9vJL4lZXxOwPONynLDbw2EYDXJhSq9dqe9lb/cpyNhXahNBs3RUXN
  /b8Ptss9fouePQ/C9aNiKORkRExcgtyX9AeX34DXBgShp6fH13c5z/kZ5TOU1ZSWlrEIlKCtrc3D
  cxn/zGrKDzqncj+or69v9RoFbkigEpevWEXjmcWhdo4ePc7f07SxXcLzVoT29navZT7KJupUOg2t
  o8eOK34S0OxCuZlGG210viRVllv0GgwLjxAqOTQVr40ipDSeFLh2XWpamiCX3n6Arq6uK1euengt
  U+QLmG8SNSN1d14+1wte5AZemwjAaxMK1XptN5oLLDSqWNRGuv7ltuJrrGLyMHUrQnxiMLw2YRQe
  eaa1Vd777PK6Xv9SjKV0sJm04LWZLGlpdzjbIjTn3rV77/j4OItAIcIjImmOIolNbtE82NvHr7Oz
  kwWhUq5f13A+/o9E6RON5PvpGSwIVdPQ0ODhuYyzCUXNuyZw7eCgvMcsvE1MbKyyKTpV2cnFLTn5
  xsSEvN/AKUVMTCxVk7PHROPWa5lPd7dAtrhJeG3UbpTDrwlcd+fO3aGhIRa6KVBfX38iKISeJnFa
  ePH0uZNqcijgtYkAvDahUK3Xdvx1EiXe0lTcRKVdkND0iFVMHlrb2sIjz2ADqTgKCgnLfSivbdQ5
  1v/HN5epx5ImwWszTXQ63a5dezhnszThTlPoVoS3KSp65rDUif/Un6p/8+YtFoRKoUm/i6s7/7al
  kbz/wEGa7LI41EtSUjJ/p5iaVxsdwyKQn/7+/sC163gmLRJR0S6ubjzX8SnChQsXOY8lejPY2i3J
  ycllEQiA+F4bPX2OTi4abbRpuWxv0OsNiYlJVAUFn+i3tdjSOvRkGLy2zxG8tneB1yYUqvXafJ6E
  W0SpZH/cj+JsKgaaWcXkIb+gEIvahFLIyYjrmmi5s7X/+2C7qraRwmszTUpLyxwcuPpNNBH09VvR
  29vLIlAOesY3bd7Kf95PJW7bvmN0dJTFoUZo2qfUDQlOzq6UcrA4VIpOp9uwcZONIrcicLwWICs7
  h//qyDei5nX38Hry9CmLRr0MDw9v37GTc1NTfhgReUqc/FBkr42ionfppk1bXr0y+bM+nz4tWrnK
  n/9Hw7uiD+LNW7YODZukcfle4LWJALw2oVCt1zY/e49KTATtgj9PXTE4McIqJgMGgyE2PjHkZITE
  7oEUVGhY5NQ20jZ5t5Gue35RPcs/SfDaTJPTp8/S57Tkk1tWUXGXL19hxSvN7dQ0ztU3inKnFy9f
  siBUSu7DRzTp55+7UhZ39aq8Jz8ozpOnT/kvyaSGPXrsOIuAC/sPHFIqJ7extV/m41dc/IqFonaq
  q6uXefvyzNKtbewD164T57gxYb02Y6dcuny1X7CbW2dMTU3NKv8A/t9ySUR97ebu2dGhnvMc4LWJ
  ALw2oVCn16af1P/d/fUWmnnSVNwUpZlr9fAgq5g8dHV3R54+J/F6IMUVFBJWUPiEdZI8XK97gHVt
  QFk6O7t8/VbwXB1Ds0AXF7fXr8tZBErT1tbm47uc8/ogkpW1bVhYOAtCpfT3D6xeHcg/oaISAwPX
  9/X1szjUCP+jBikvpcckn+PdkS0trcu8fW1s+eWNb0Q1dXJ2ffJE/Sva3uZ2aipnc5yKU/aGnLcR
  02ujoUhR3Ui5qbJE+vXr1z6+fvw/eSWiANR0LTi8NhGA1yYU6vTaesYH/+z2cgutKg6i0szb9UrD
  KiYPL4tfYQOpgKJOiU9MlvXNVdRT/cOp63oXSEediQpemwmSducuZyvEytp2z559rHgxiIg8xdm2
  INEU38d3eXNzCwtCpVy9dp1/25JoVBcUFrIgVEdnZ+fU1Zx8TYEpB3PtOp4ra+7du8f57WSU0VW8
  fTuVxWE2jIyMbNy0hXOKmJCQKEiKKKDXRuPQ2cUtPT2Thagunr94wdkYelc02u/eu68ajwJemwjA
  axMKdXpt9UMdv5vsqhIHQTNPU5/NKiYPd+6mB4WESYweSHGFhkWeu3B5YEDG29Y6x/p/J9lFJa40
  CV6bqaHT6bZt28E5m7Wyts3KzmERiEFJSakiKZaVtU1Kyk0WhEqpqamhXFGJtrU9dvwEC0J13Lx5
  i78JRU0apdGyCOTHYDAcOnyUCpWEwUHWNvYXL12mAFgo5kRu7kOeTyv17/4Dh+C1vVe2dktc3Tx4
  riTlz40bKcoubTO+1lRjUsBrEwF4bUKhTq/tVV/9D2OtpXm4SWrhFzGL87tk3OtEue6Va1E4rE1M
  hYZFVlfLeMC2blL/V3cDVbLbmgSvzdR4+bKY85FPNKv2D1jd09PDIhCD8fHxnTt38zcvqMQNGzdT
  6SwONaLX6w8eUuCGBBppy7x9GpuaWBwqgubxO3bs4tyk9JZwdnGrr29gQchPW1s7JY2KuLT0NhgZ
  UfO9JR+AXkc7du7mNrroHbjKf3VfvxDbvYXy2igMW7slaXfuqjt/pvG2b/9BSyXWPhtFRavpKlJ4
  bSIAr00o1Om1ZXW8kibhJirtgt9JdqkdamcVk4GOjs7IU2dDwyIlLg8kgoJDw3Mfymse2Tw8bKGa
  6xHgtZkaEZGnOGfsVJw4tyK8zZ07d21s7TlnWVScw1Knx4/lPRdScR48yKKa8s9gabDdUOOywbKy
  10sdnTm3JzXm0aPHeS71unU7lf+CF8pRnUU6TVIR7ty9yy1Xp4KcnF0FOTBLKK9tsaXNpUtXzGFx
  ZU1NjYfnMp720NuytLLZs3cfvLYZC17bu8BrEwp1em2a+mzVbCD992mrRvQyLjp4/boiCIe1iaqQ
  kxHJN+Q9j3bji0sWUV9KB56JCl6bSdHW3s751jnKYSiPrampZRGIRE9P7/IVq/jn9pbWtqEnw1gQ
  KmVgcNDffzX/VMraxn7T5i1jY2MsDrVw/vxFmlhLKiurjO5Dbu5DFoH80MfuwYOHLa14L4e0srbV
  xsSwIMyVnt5eX78V3B7YxZbWqalpImSJ4nhtlKUfOnxUfe+ub+Lqtes8jYm3ReVu2Lh5eGSEhWLi
  wGsTAXhtQqFOr+346yQLjTouRpj7ZdZOVit5yMp+CK9NZF28fE3W6c7pqlTsIQWKcPPmLc4ZO+Wx
  h48c1ev1LALBuHCBt4VBoryOZsbNzc0sCJVyPUqz2FKBtqXM+fnzFywIVdDX379iJW9TmIoLWB04
  PDzMgpAfeiLcPbhmjCRKjTZu2jw4KOMhraYCvQzpdS1pH5lEBQmyiU8Qr40et2Xevo2NKtz//k20
  tLRMXfbC/fsYErX2ipX+HR0dLBQTB16bCMBrEwp1em1bXl5ViX0QNce9IITVSgboqUhIuoFLSEVW
  xKmzHR2drMNk4EZzAe4hBfyhqcDmLVt5TgUogSHxXBrzqbx+Xe7IfWseiVLN2Lh4FoRKqaiodHXz
  4J9KUdtSGsCCUAWZDx5QM3IepTSPj47mutorJ/chZ+ObmpQaNicnl0Vg3hQVFTk6cXoZ2kwf4inC
  Gi5BvDZLa9vk5BRzS5svXrrMzd59W/TUu7l7irncfgbAaxMBeG1CoU6vbVXRGQvNXGkeboqKmrPl
  5VVWKxkYHR27ek2DixFEFvVORWUV6zAZKOyu+E70IunAM1HBazMdnj9/zvlWBGsb+zWBa4c4Lo35
  VPR6w569+/lP92lCtmHj5qEhcVtmVth/4KCVNe9dQja2S3z8VqhmzQLN4A8cPMR5iP48F5XxmqB3
  OXPmHOdq0uDcsXP3uE7HIjBvBgeHVq4K4LN8kj6GnF3cmltaWNnKIYLXRsN+2/YdPNeQCkJ1TY0i
  38dQd5OKi1+xOEwceG0iAK9NKNTptXkUhlpEqcNr+zKsUsaTlXt6+06fvYCLEURWUEjYkydFrMNk
  oGao7ZfjbKQDz0QFr810CA+P5LxshIrjvDRmBmRkZPBJL98WTfRpZlxY+JgFoVJycnMVWbZAA+/e
  vfssCBOntrbWydmVsxdAvXbo8FEWARcoYdi4aQvnVbf0a35BIYsAfP11UFAInweWGt9hqdPTp09Z
  wcohgtdGpRcVPWMBmRMGg2Hnrj2KfEYsWmylmhuK4LWJALw2oVCn12afd1Ql69o082IaZNxQ0NjY
  JHF2INEUFBKWnv6AdZgMtI32/v4NNwvtQunYM0XBazMR2tvbPb28ec7GqCxXN4/6+noWgaj09fVN
  35DA+6t1SjCOnwhiQaiUnp4e/4A1/K1Matvdu/eyIEyca9ei+OeilDDkPuS69bupqcnb25fnY0it
  un3HzokJ9d/5+PFkZGZyG2z0Wki5eUvxRFFxr23qZbVn39i4jBeyiUxSUjL/DwjSosVWWdnZLAgT
  B16bCMBrEwp1em0Lc/ap4ry2hd+NXnS/7TmrlQyUlJZhA6ngCg4NT0xOYR0mAwMTI/8ubaWFVhV3
  icBrMxESk5KtbbjOaCmFOHrsBCtebK5cvcbfzqCZsYenV319AwtCpVy6fFWRtnVxdS8vr2BBmCz9
  /QOBa9fxnL6TKPVdvTqwr6+PBcGFvLx86jWelgclKvfTM1jxYJqq6mpHZxc+vbDY0vrsufNm7rVR
  uaScXPM9MbCpqcnZxY1/+9Pwu307VR0+Bbw2EYDXJhQq9NoMk4b/nblNDfeQahf+INYqr+s1q5gM
  FD5+Aq9NcFEHXddEy/f+Gjfo/vbeWtXcJQKvTXyGhoc578+yXzKVQuQXFLAIxKaqqlqpU/y10bEs
  CJVC2bsTr+z9bRmnoSwIk6WgoNDGlqvRRqIXxfUoDYuAF9euR1H2K4lEPtnY2i9fvqqzU8ZLkEyR
  np6egNWBfNYZ0dvv4KHDExMKX1GtrNdGTb1h42YR7ohQitHR0W3bd3D+OoFEb5uY2Dh4bTMTvLZ3
  gdcmFCr02sYNE393f50a1uloF/wozvZFn4x30zzIysElpIIr5GTEpcvXxsZGWZ/NNobJyf+RsRle
  G+BG0bNnnI0kSiHWrls/MjLCIhCeAwd4Hz9PolZaE7huYGCABaFGaALK/2h/ErWtf8DqoaEhFodp
  cvx4EOems5s+tL62lusNfRN6/c5du3lmKdSqZ86eY8WDt9izd7+lFY8hR0/ounUb+vv7WcEKoazX
  tsjSWoSNtMpy7twFS44+u1GWVjaXLl2G1zYzwWt7F3htQqFCr214Yuw/pq2y0C6Q5uEmJ+2CX0tY
  Ujko49VIqWl34bUJrtCwyLPnL8q6g2ZO1k7V3NsLr018goJDOWfsVFxCYiIr3hR4+PAR5X6SWnAQ
  zY+paBaESnmQlW1jy3V7IMlYXE6OCW/Oampq8lrmw9klpyf38OGjnKfv3d09Hp7LuNWUxsYSB8fS
  0lJWPHiLs2fP80kXqRdcXN1bWlpZwQqhoNdGA96N+22/ApKenkHtz7kLLK1swsIi4LXNTPDa3gVe
  m1Co0Gvr1w3/6S0fNZz1rl3wm4mOzSPdrGIycCPlFvaQCq7QsMhTZ851dck4DCxzD6jl3l54baLT
  2Njotcybp5FEcz6vZT7Nzc0sAlOgv79/TSDvg7FIVlMXPh5hQagUalt//9X8rUxLa9tjx46b7kw0
  KSmZs0VO6S49vLnczd/Hj5/w9DumVlSt32hCq255cvfefW4dQcO7tLSMFawQCnptVP2dO3cZDOZ+
  O0dNTa27hxdPq4hEn/X8v1SQCXhtIgCvTShU6LX16Yb++KaXKry2+b+T7NIzPsgqNtvQI5GQmAyv
  TXCFhkVGnDrb1t7Ouk0GnPKPw2sDfKCMnT6SJR/SsopSiODgEFa86UCzFs7WBonmx65uHpRssCBU
  ypUrVzkPQhLlz9S2jY1NLAiTYmxsfOPGzTQeJZWSVZQnBAQE8t/UnJTM9S7CxZbWNCBZ2eAXqaio
  WOLgKGkxmUTv23v37yubKyrotdErMTExCany6Oio3/KVnL+MoXfdzp271dH48NpEAF6bUKjQa+sd
  H/qjFE+LaDV4bb+b7NqvG2YVm230en10bHxoWKTE3IEEVJOcq3JcC4LhtQEOjI2NrVu/kecslpIW
  WzuHomcy3uYsE/X1DU7OrvyTLpowRWm0LAiVUlFZ6eikxA0J1rZx8QksCJPi+fPn/C0AGorXrl9n
  EXDk9Okz3C5GoCalhn38+DErG/wiPT29lLfzGXhW1rZXr14zT6/NOA5V/y3LR7Jl63aeJgWJituy
  ZRu8tpkJXtu7wGsTChV6bT3jg39ww10dXtvvJbsO6OTaWUCPYpQ2Bl6b+Ao5GdHQ0Mi6TQbcC0NU
  47XdbEbSIi75BQWcEwkr66kprCnuzzIYDMePn+C/tM1m6hT/NQODcq2nFgG9Xr9//0H+bUsT3w0b
  N4+OynXRjXyEh0dwbi56Szg5u3K+FYHgPDbocVu5yr+/X80XknwOQ4NDAQFr+OTt1OmhoSfN02uj
  cbh26moIjMMp+L/uqLR16zfCa5uZ4LW9C7w2oVCn1/b7N9xU47UNTsiVJep0uuuaaHht4ivkZER9
  fQPrNhnwUJHXltxcwGoFBIM+g08EBdPnseQTWlbRVCMpKZlFYGo8fJRHVeCcd1FxtnYOWVnZLAiV
  kp6RyXmXEInalhLpZ89NbJVle3u7j68fz9yJRLnuoUNH+J8e1Td9VCK3sUHVPHL0GCsbvMPY2Nj2
  Hbv4ZIzUF3v27jNPr40+l4NDQpEnG0lISOTstdELZ/WaQHUclgevTQTgtQkFvDaBJfMeUnhtpqIp
  r61BRq9NTXtIk5ryWa2AYDQ1Nbm6efDMImi25+G5rL29g0VgaoyOjgau5Zf2vxGlGQcPHaa5GotD
  jfT19a1YsYqzf0QyZgUsCBPhzp17lla8F7WRHjzIYhFwpLm5xcXVndtrisZDUvINVjZ4B4PBcOwY
  p+W9VMqmzVuU9TuU8tqo7olJyciTjWRlZdODKWkiWUWf8itW+uv1ehaBKQOvTQTgtQmFOr22P0zx
  UIfX9jvJLr3jQ6xisw32kJqK5N5D6px/QjVe2w2saxOV6OhYzt8Vm6KvISEhMYnzpJ9EmZ6jk0tl
  VRULQqVcuXqNf9tSBrLM27ezs4sFITw0dea2sOiNKPNc5b96UImNzMWvXllZ86ssNeyrV69Y2eB9
  nDl7js8HB/XF6jVr+d/F8TaKeG3GF/6LFy9ZEGZP0bNn/N94fstXjo+PswhMGXhtIgCvTShwN4LA
  0i74WZJTy0gPq9hsg7sRTEhNzS2s22TAKveges5ra8F5bSIyNDS0dt0Gnh/8P88fXrAITJOGhgYv
  L28b7suvKLm9eOkSC0KlvC4vd3F157y0jYYlpVWpqaksCOEpLS1zcnbl3Eo0a1fqgo60tDvcvhKg
  keDrt6KtrY2VDd5HdHQMH0/c2B2trUp2hyJeGz3d7h5ePT1y5RomR1nZ66WOzjx7wTj2hk3wYNl3
  gdcmAvDahEKFXlufbuiPb3pZaNXgtf16gkPVYCur2GxDj0R80o2QkxESWwcSSqFhkRGnzra1t7Nu
  k4E5WbssNKrw2jRzb7U8YbUCIlFQUEgzV56TV5pkbN22XQWbMk4EBXNeD0iiqb+//+qurm4WhErZ
  vWcf5/ULJOrNXbv3msoShitXrvJxOt6IkjQXVw+lllWeP3+R2+M2NRJ27VH3Zu3P53ZqGp+HdMpy
  cvesrq5mBSuBIl4bve0DVgfqdDoWhNlTX1/v6eXN0y2iLvDx9etXdE3lbAGvTQTgtQmFCr22ft3w
  n97yUYfX9uN4u5d9daxiMnAj5Ta8NsEVGhZ56sx5+ZLeya8n/2fGFgvNPOnwM0Vp5qW1FrGKAZE4
  euw4Z8OIirt79x4r3pQpKiriOW19Iytru8zMBywIlZKVlc15WJIokXZY6lRRUcGCEJiB/gH+p9pR
  j+w/cJBFwJ19+w9wGxKUnIRHRLKCwTfw8OEjBwcnDvaT8cF8+bKYFawEinhtlJAfPHRYHQfzzwrt
  7e3LV6yy4XhSqs302QLqWFoIr00E4LUJhQq9tuGJsf+YtspCu0Cah5uctAt/EGud31XOKiYDqWl3
  g0PDJeYOJJRCwyLPnr/Y19fP+my2GTfo/vbeOlV4bQu/E/1VVoeSE2XwXurq6tzcPTh/S+y3fKXp
  3orwNkPDw5s2b1Fo+dUeFoRK6eru9g9YzTOnMopmpRcuXGRBCExGRiY9tpwzfxp4ObkPWQR8oSxh
  46Yt3Lw2GniJiUmsbPANFL96xe22Cnow8/KVvF5JEa9tsaX1xYuXkSS/obu7xz9gDc/PBXrNLvP2
  VcdCcnhtIgCvTShU6LWNGyb+7v56C+38d1Jxk9PC78YsSm+X8byhB1k58NoEV8jJiEtXro6NybXh
  aHBi5N9PedOm/7xoF34/1qqw2wRWi5gbWm00t/TVKCru1OkzrHjThxJy/l4bzZVdXNxLS8tYECrl
  /AV+ewbfiHozYPWa3t5eFoSQ6PX6Q4cOc24cym/9A1Yrtb5jaGhoTeBaPs+a3fSe+vyCQlY2+Abq
  6uo8PJfxSd0XLba6e/eegumiIl4b1fr27VQkyW/o7+8PXLuO52fuz702k7kz5wPAaxMBeG1CoUKv
  zTBp+D+Z2yw0KvDapvbExTc+YhWTgcdPnmIPqeCiDrquiZHv/dUx1v+HKZ6qWAe64Ccy77kGM2Bg
  YGD1mkCeXxFTokLpSlnZaxaB6dPe3u61zIfn5NUomjxdvHSZBaFSKiurHB157FCTiJ6I3IfKrN76
  SOrq6pxd3Di3jJW17eUrV1kE3Glra/dbvpLPy4oa1mGpU2OjjDeMq4P29g5vHz8+b7/FltZx8Qnm
  5rVRrQV/F3FmeHh4w8ZNvL22ZT4mdD/1B4DXJgLw2oRChV4bsTBnr0rOn4r6MqLyNquVDJSWvYbX
  JriCQ8OTklNYh8lA7VD7j+PspAPPFKVd8NPEpVWDMl7YCmZAbu5Dnp/3JErXd+/Zp47r898QGXmK
  pjKSmsotmi77+C7v7lbz/XQ6nY7nEV1vRCUeOnyEBSEkURot5yFnN313cHVNLYuAO9XVNdyWUE0/
  XH79/XKdDqEaBgYGuRmgNOCvXb9uVl4blUVD8elTHHT7T4yP6zZv2cbzQ4G6wGvKa+tkEZgy8NpE
  AF6bUKjTa1uSd1Ql9ypGzdlWfI3VSgaampolzg4kmoJCwtIzZDyh/ElP1XdjFkkHnilKO/93kl2b
  RtTwxaCa4LwNjTIHysru3bvPilcLL1684L/egUSNmZqaxoJQKenpGZQYcG5bKtHdw6u+vp4FIRgj
  IyOBa9fzd8kPHDyk4N3BL18WL3V05jMSrG3st27bPjo6ysoG3wCNh1X+AZy8Nmvbc+cvmJXXRi8i
  RyeXktJSFgH4+muDwbB9x054bTMDXpsIwGsTCnV6bR6FoRZRKvHavApPslrJQG9v3+mzF0LDIiX+
  DiSOgkLCnjx9xjpMBm62PFbDpb0k7fw/TPHoHlfDpemqoaam1tWN960Iy1es6uvrYxGoBZ1Ot2Xr
  Ns7eB4nyjV2796hskaAEGi0rVvrzSebflpWNXUxsHAtCMAoKCynh55nzU1n0osjKymYRKEFeXj63
  BNvK2u7QoSODg4Ojo6Mj4Juh9lkTuJbP40m9Hx4eaW5em7uHV01NDYsATLN7zz5LK3htMwFemwjA
  axMKdXpt/kVnVLKuTTN3btYuVisZGBsbu3pdg22kIot6p7KyinWYDJytvquSDdea+X9y03tEr2ZT
  wOS4HqVZbMl1Gxp93l9R7rwnWbmdmsrzm3ajprM+x5ISla96uHT5Co0cSd3lFnXmuvUbBgeHWBAC
  MRkUHMIz1STZ2Nqv8g8YGFDyy5I7d+8uWmwtCUwm0ZNF2fWWrdugbxW3e0jpBXvs+Amz8troufP1
  Xd7SgsM3foF9+w/w/ESA1/Y5gtf2LvDahEKdXtvWl1fVYh/M+4s0/1G9jlVstqGnIjE5BVeRiqyI
  U2dlPTB1W/E1i+tfSgeeKUoz79+lrjDgRS8MQ0ND/gGreS4Xoumds4trRWUli0BddHR2evv48pzC
  GkVTqNOn1HOp63upqKhwdHLhmeIaRb35tEi4k5La2tq4HVv2RjTMrlyR8cSMjyE2No5zgk25EPSt
  4vZgUln7Dxw0GAxsQHCHv9dGVV7lv7qnR+g7kflDw4DzqwBe24xFPQWvTQK8NqFQp9d24nWySu4h
  1S74Z8muDcMdrGIykJP7KAhem8C6dOXa2JiMa7WW5h2ziFKH1zb3v6VvYrUCApCVnU05A8+0wcra
  du++/Sr+sD91+gz/pW02tvZ+y1d2dMj4MaQ4er1+z959/NuWSgwJkfGYiJmRmJTMc45OoreEo5NL
  VZWMK7g/hnPnL/AfA5A4omG/fcdOBU8MVMRrW7duA84NlACvbcbAaxMBeG1CoU6vTVufbaFdIE3F
  TVILfynGsrC7glVMBsrLK7GuTVgFh0bcSLkl38trYlL/t/fWqeXS3jl2jw6zigGloU/6AwcPcU5c
  aWKRla3keU9yU1JSosjyK2rY27dTWRAq5f79dJ4TU6NsbO29BdvANTIysnkL75MB6UWxf7+S64mM
  hIaehNdmzqLncf36TfThxQYEd/h7bTTgN23eajAgQ/4FaPYCr21mwGsTAXhtQqFOry2745U0Dzdd
  aebFNOSyislAR2dX5OlzuB5BTAWHhj98lM+6Sga6xwd/N9nVQquKRaBRX64uOssqBpSmurra0YnT
  jX5GUZq0yn+1+m5FeBuaP+3YuZu/JUQlbt22fVwn12kGItDT0+O3fCXPDMEomqGmpd1hQQhAcfEr
  /o1AJWZkZrIIlOPoseP8Hy5IHBk/RHTKvegU8do2b9mGDFkCvLYZA69NBOC1CYU6vbZX/fU/jLOR
  puImKs28vSXRrGIyQA/k1Wu4HkFQhYZF1tTUsa6SgRe9tT+Ks1XJItDr/3iwNJZVDCjNxUtXOK8Q
  oeKuXY9ixauXe0osv6Lcz2Gp0/Pnz1kQKuXCxUv8lzVRb27fvlOcGWpExCnOjUBZ2dTdwf39LAKF
  oC7Yt/8AvDZzFg1Fbx/fsbExNia4o4jXtmXrdmTIEg4cPAyvbWbAaxMBeG1CoU6vrWG48/emVuuo
  wkHQzLV/dIRVTB7u3c8ICgmTuDyQ4goNizx/4bKst9TFNT5SycmGJM3cCzX3WMWAonR396zyX83z
  Y54mdq5uHjW1tSwC9dLT07Nylb8NxxsnjKKULCw8ggWhUsrKXjs7u/JMdEk0dJ2cXV+VlLAgFKW9
  o8Nv+UrOo4vm6FevXmcRKIfBYNi+Y6e1De8nCxJHRstjcHCQjQnuKOK1bd22AxmyBHhtMwZemwjA
  axMKdXptveNDf5a6XCU747Tz/+JOwPCEjN+zvXpViiPbBBR1SmLSDVnfXNuLr1tEzZEOOZPVzebH
  rGJAUR48yOK8NIaKO3zkKCte7Vy4cJFnGmDUdDLg3drayoJQI/Sy3b17L/+VTdSbFy9eYkEoyr37
  6ZyfXBpXLq7uFRUyHkr7kej1+o0bN/N3sSFxRKPR08u7r0+xJZaKeG3btsNrkwKvbcbAaxMBeG1C
  oU6vTT9p+Lv76y00cyWpuInqx/F21YMyZjjdPT2Rp89JjB5IcQWFhD1+8pR1kjzMzdplEaWSx+T7
  sVaPuytZxYCi7J260pHfZzxlJjSxy8vLY8WrnYrKyqWOTpyXX5EsrWyTb6SwIFRKRkYmZ7OJRKN3
  +YpVvb0KHzU4aTDs4m41Umvv2buPRaAoOp0uYHUgvDZz1rTXtqy3t5eNCe4o4rVt3yHQHnZBgNc2
  Y+C1iQC8NqFQp9dGLMjZoxqvzUK7ILmpgFVMBgwGQ3xCEo5sE0qhYZHhkWfa29tZJ8lA9/jgn9zy
  Vsnyz+ivfhJvVz/UweoGlOP169fOLm48Z1o0n1i7dv3QkIy7rYWCZlH79h/gbwlRO2/ctEXBw4w4
  QNnOylUB/A0XKlHxywHoyXXifsstDeOsLCHuDh4fH/f1W8HzxQWJJup9D89lPT09bExwB16bIMBr
  mzHw2kQAXptQqNZr830SoZoFOxZRX+4p0bKKyUPh4yfYRiqUQk5GaKJj9Xo96yEZKOqp/uU4a4vo
  hdLxZpJa+IcpHr3j5uK2iMylS5d5TlJJlC1oo2NY8eZBekYmf1OAMkDKA58+lXexreKcPXeBv49J
  Je4/cEjZeSo9uZwrTpnAKv/V3d3dLAJFGRkZoXQXXps5y+i1dSk3IOG1CQK8thkDr00E4LUJhWq9
  tqDyZPUcRBU1Z1727q+/lnEEt7d3RJw6ExoWKXF8IKUUFBL2MC+fdY88nK2+Y6GZJx1sJirN/H9I
  36QzyGhNgo+ht7fPbznXtSGUlri4ujc0NrIIzIOBgYEVK/1tbHn7AjSdOhkWzoJQKeXlFZTuSiou
  t+iRmb7cQ8Zbpz9MX1/fKv8AziOK8vwLF4Q4qI6gd5enlzfPdxckmqj3PTy9FLQ84LUJAry2GQOv
  TQTgtQmFar22lOZC9VywqF3wu8mu7aMyHiExvY00GUvbxNH0BlJ5d0QuzTumnn3WmrlO+SdYxYBy
  3Ll715rv/jtKFU4EBZvhB/z1KA3PZMCo6Vx0WXNLCwtCjYyNje/es5fzCi8S9WZ0TCwLgjvZ2Tk8
  5+UkO3sHh6VOlZWiHLLZ0dHp7uEFr82cRb1PY6CjQ7HDKOC1CQK8thkDr00E4LUJhWq9tqKe6h/F
  2VpoVbI/7nvRC++2PmN1k4fnL17CaxNEIScj4uKTZN1AOjAx8me3/Sy0C94ZbKYpzbydr6JY3YBC
  6HS6Xbv38DQpKCehzKSgoJBFYE5UVVVzntEaRbO32Ng4FoRKuXv3PjUsz4yXRM/NmsB1IyMjLAi+
  HDh0mLO9SMXt239Qp5tgEShNW1s7vDYzF/U+jYG2tjY2JrgDr00Q4LXNGHhtIgCvTShU67V1jvX/
  sxtuqjn33SJqzo7i66xu8tDfP3Dm3EVsIxVBwaHhL168ZB0jD096Kr+IsZQOM9OVdkFUvRAHbJsz
  r1+XL3V05pkn2Njar1u/Qd2n9X+AAwcPcfZHSDR727Bx08DAAAtCjfT09PA/Jp8eHAcHp8JCBYzj
  2tpad77ZEVWWikvPyGARCEBbWxu8NjMX9T49CK2tMt77/2HgtQkCvLYZA69NBOC1CYVqvTbD5ORf
  3w1U0XFUc/97xmb9pIFVTx7u3c8ICgmT+D4QZ4WERV64dGVQ5ksVpw80VMsG0uivvhez+HF3Basb
  UIiz587znJ6SKE9ISr7Bijc/Hj3K5zmXeiMbW/vHjx+zIFTKhQsXOQ9mEpUYejKM/2w1Njaec2Vp
  CK1Yuaqvv59FIAAtLa3uHgosFIXEEfW+m7tni3J75OG1CQK8thkDr00E4LUJhWq9NsL+0RH1XI+g
  XfjrCQ4VA82sbvLQ1NR8MkJq/UCcFRQSlpWdy7pENuZn71HR07Hgd5Nd6ocVO2MFEF1dXX7LV1AK
  LfkAlk9U1jJv36Zmed+KItPf3x+4dh1/u43Ss6PHjrMgVEpZ2WtHZxeeSS+JinNz92rlu4VtbGyM
  RhHPJ5dE8/LLl6+yCMSgpaVFkU3ZkDgyem0KfqbAaxMEeG0zBl6bCMBrEwo1e23biq9ZXP9Smpab
  rjTzTlWlsrrJw9QNCYlJwScjJO4PxE2hYZERp892dMj7iVs33PHTREc1Hdb2F3cChvVmupFQEO7e
  vcc/XQ8JCWXFmytRURpKliQtI7doGu3huay2TrFLMzmg1xt27NzNv21pcsx5qWZ+QQHn9J7KcnRy
  KS8XayVyc3MzvDYz17TX5tGo3K3W8NoEAV7bjIHXJgLw2oRCzV7bpdp09ewhJWnmLczZa5B5HFdU
  VuHINgUVFBKWeuce6wzZuDz1aKhnAynVhR4NVjegBDqdbsfOXZwXWNFk7vnzFywCc6WhocHF1Z1n
  bmYUzati4+JZECrl7t17/L02KnHb9h3cjiCkmXHoyTCeWSWJ6rh7zz6DQd4zMT4VrGuDqPdd3Tzo
  pcrGBHfgtQkCvLYZA69NBOC1CYWavbbCbnWd/h698GdJTk0jXax68qDTTcTEJuBCUqUUHnm6uUX2
  c3mnt1eryGuLmrOt+BqrG1CC4uJXnDMEmkNs2bpdqUsbxcFgMJwICuZvCdnY2q9es3Z4eJjFoUaM
  26I5my/0EC1Z4lhSUsqCkJnW1jbKizh7tfTwpqcLdCuCkdbWVtyNYOYyem11dfVsTHAHXpsgwGub
  MfDaRABem1Co2WvrHh/4gxvuFtqF0szcdKWZd6VW9hlqeXlFCLaRKqHg0PCbt9PkflU1j3T/s2RX
  9WwgJWnmJTTlseoBJaCJDme7h+YQyTdSWPHmTX5BITUIZ7vEWFxOjuwnSyrLmbPn+PuYNGc9c+Ys
  i0BmkpKSOVeQcjC/5St7enpZBMKAe0ihKa/N1b22VrHd8fDaBAFe24yB1yYC8NqEQs1em2Fy8v89
  2KGqbaRRcxbk7J38Wt6hTI9obHwilrZxVmhYZOTpcy3yXzZ/vvqehXa+dGiZrrQLfiXBvrRfsQNW
  QHt7h7ePH8+plZompp/P2NjYuvUbeE6qjKIk7eixE3rBdgLOLiUlpUsdnTn7mDa29stXrOrp6WFB
  yMb4+NjWbTs4e22W1rYXLl5iEYhEW1s7vDYzF/W+i6t7dU0NGxPcgdcmCPDaZgy8NhGA1yYUavba
  iMBn51R1LpV2wa8lLJH7NlKiprYOp7ZxVlBI2P30TNYBsmGYNMzJ2qWucwzn/+vbviP6cVZDwJ3b
  qak8Z6UkKu40r4U/JkFiYhLnLiBRQujk5KLgGhAOTOj1O3ft5uxjUsPa2NpnZMi+hr24+JX9Eq6J
  PSVgTs6uZa9fswhEorOzy8NzGbw2c5bRa6uqqmZjgjvw2gQBXtuMgdcmAvDahELlXltUfRal4tLk
  3KQVNefo60RWPdkwGAwpN29jaRs3hYZFnjl3sadX9m01Jf0NP463lQ4qk1bUHJuHh1j1AHf0ExNb
  tm7n+YlOeYijk0vxy2IWAfj666amJk8lbAJLa9srV1V+VOLde/cUWTO4/8ABvV7PgpCH02fOcrZo
  qV67du/5WsjpeH//gKeXN7w2c5bRa6utrWVjgjvw2gQBXtuMgdcmAvDahELlXtvz3ppfjrO2iFbV
  kW3/9f76MYOO1VA22traI0+fw+o2PgoKCSsofMyaXk4OlMZYRM2RDiqT1vUv95ZoWfUAd168eMl5
  kx3NHrbv2CXaJYaKExJ6krImSVvJLeqLNYHr+vr6WBBqpKOj02/5Shtbe0ndZRU9UM4ubjVy7mXr
  6e3lXy8aMBkZsi/fnhmjo6OU7sJrM2dR7+MeUkDAa5sx8NpEAF6bUKjca+vVDf7r276qOp0q+qtf
  irHMaH/JaigneXkFQSFY2ia7Qk5GaLSxY+Oy74Icnhj7D2n+qtpAGv3Vd7QLbzQXsBoC7kREnuI5
  JSVRbpCSclOn0w2Dn0OtQUkazwztjWxs7bNzcthoUCnT6794+5g0zq/KuWbw7r171Hd8XXL7lav8
  u7rkvUt9xtBD5Ld8Jbw2cxb1vpu7Z3Oz7Oe0fBPw2gQBXtuMgdcmAvDahELlXhuxIHuvRZSKjmwj
  aeY55h3nMJxHR0eva6KDcSepzAqLOF1by+OO+YSmvO+qy3cm/Uq8fc1QG6sh4Et7Rwf/XVeUh6xb
  v3Hrth1btm6HmLbt2LRpCyVpkrbiIErV9h9Q+SbusrKyJQ5TA09Sd1lFs+RA2dYMjo+P792738qa
  695YSyvbc+cusAjEg5KT1WvWcl7oBwkl+ixz9/Bqa1NsRgGvTRDgtc0YeG0iAK9NKNTvtR0oibGI
  +lKSn5u4Fv56gkPFQAuroZzU1tWFRZyWeEPQLCooJCzzQTaH15N+0rAwZ6+qrgohaef/9d3AUVyM
  oBDJN24okppSoTSHgCSStBIf0ZTa1c29orKSjQk1MjY2tmPHbkpKJXWXWzTOZTpboKqqytHJhWdK
  T2UtcXB8/bqcRSAeE3r9ho2b4bWZs+ht5uHppaDlAa9NEOC1zRh4bSIAr00o1O+1PWgv/iJmkaqO
  bCNFzdn56jqrocxk5+TikgSZFHIy4npU9MjoKGtrOXncXfnLcTYWWpU9CPNWPj3Nagj4Mjw8vHnL
  VqUsHkgcUbZ26fIVNixUyu3UVP4uDDXsseMnWASzysVLlzlbh1Tc7j17x+U/KmHG6A2G7Tt2WtvA
  azNfTXtty3p6etiY4A68NkGA1zZj4LWJALw2oVC/19Y7PvRHKZ4qO7LNQjvvX9707h4fZJWUk9HR
  UW1MHOy2WVdoWGR45JmGxibW0DLj8yRCbYvaSNoF8Y2PWA0BX549f85zOgUJKxu7JctXrOrpkf0a
  ZQXp7u728V3OecDb2Np7LvNpbGxkQcwSvb29AasDec7C7ewdqOnu3r3HIhCSScPk3n0H8OWBOYtG
  qaeXd39/PxsT3IHXJgjw2mYMvDYRgNcmFOr32gjL3ANqu3uRpJkXXnmL1VBmWtvaTp+5gDtJZ1fB
  oeGFj5+wJpaZysGWnyYuVdvqTu2C30x0rB5qZZUEfAlV4uJLSEzRlC49XdD7JWeLs2fP8cy+jKJH
  LCXlJotglqB8nrOjRHmXr9+K3l6h3VhKEg4fOQavzZxltDwGB4fYmOAOvDZBgNc2Y+C1iQC8NqEw
  C6/tRHmSGr22+X+euqJPx2lO8KqkNPQdtwiasYJCwm7dTtPr9ax9ZSbw2XnVnVpIj8Dc/5axaWKS
  UxuCt2lqal62zAdnG0FGUcK2Z+8+g8HAxocaKX71ivMZZySaK2/avHV8XMeCmA0OHT7C2SWnWfiF
  ixdZ8QITHBzKuWVoOEHiiD7RvJb5jHI51uO9wGsTBHhtMwZemwjAaxMKs/DaCrsrvoixlCbqKpB2
  fmRVKqukzNDzk5WNg9tmR1PHtGmih4Y4+aQ1Q20/S3Ky0C6Qjh9TV9SXW19eZZUEfElOTuE5E4UE
  FyWHjk4uZWWv2fhQIwaDftv2nZzXPVHDOix1ev78BQvis6mrq3f38OKZCFFZjk6upWVlLAKBOXvu
  PE+vjTrXFhJJ1PnLlvkqeKogvDZBgNc2Y+C1iQC8NqEwC6+tTzf8p7d8VOg1aBf8h7RVgxMjrJ4y
  o9Ppkm/cDAoJkzhH0Ccp5GTEuQuX29rbWbPKz+aXVyyiVHdSW/RX341ecLuF0yZc8DaUiqzfsAmL
  2qC3RTOtCxcusSGiUtLS7vC3mCkZPnV61m6AiYtP4Lx0i4rbuXP35KQJrHmMjonl1r/0/tyydVva
  nbt37967c+cuJILoAc/KylJwfS68NkGA1zZj4LWJALw2oTALr41YkndUlXaDhWZuZNVtVkn5GRoa
  uq6JDjkZIfGPoI+U8T6E6ppa1qDyUznQ8ttJzmo0muf/TrJL26iaj2MXloLCx5zzAUh82dja+y1f
  qe4bEtrb2339lnN2mSlp8fFdPitp2OjIyLr1GznHT8n8vXtC34rwhrS0O4ssrSXxyyRqliNHj3E7
  RwKYBPDaBAFe24yB1yYC8NqEwly8tos16RaaedJ0XQWaupB0WesovxvKO7u6Ll25Drtthoo4Vfyq
  hDWl/Ex+Pen9OFyF14+SouZ8lbOP1RPwJSg4xNIKtyJAvyDKD21s7dPS7rBRolJOnTpD2amk7nJr
  2q66zyL4DB4/fsLZIqch4eu3oquri0UgNg8fPeKWYFvb2G/dtl3Bo8GAgMBrEwR4bTMGXpsIwGsT
  CnPx2qoHW6fuYVTf6h6SZu6O4ihWTy60tLaePX8JdtsnKTQskvT4SRFrRC486an8SZyNdMCoQ5q5
  4ZX8VnSCNzQ3N9NECovaoHdFE7tdu/coeNoRB4pfveK/qJPy4V2797IIPoMQ7ncHU3Fnz55nxQvP
  s2fPuXUu5aIrVvoPDAyysgGA1yYM8NpmDLw2EYDXJhTm4rVNfj05J2uXOreRahf8LNGxcrCFVZUL
  dfUNp89eCA2LlDhK0HtFDRVyMiIvv5A1Hxf0kwbL3AMqvIF3Sgt/Em9XMdDMqgo4EhsXj0Vt0HtF
  KSIliiUlpWysqJHx8XH+NyRQ3uLi6l5eXsGCmBGtra3LvH15pkA0HpY6OpeU8FvK/ZlUVFRwyxKp
  cRydXNSRXYPZAl6bIMBrmzHw2kQAXptQmIvXRoRV3lKn10aK+tKjMHTya65DvL6+4ez5S7DbPkbU
  SvkFhZzfQIlNeV9MDY+F0tGiAmnm/a/MrXpTOGxbZQwPD6/j+/kNmZYoc6NZLxsuKiU19Q7/R4Am
  steuf9YC9pu3bvPMHknUSjt37jahI8mampp9fP34nGdnNKbLXqv56l7wqcBrEwR4bTMGXpsIwGsT
  CjPy2kr6G34Sb6fObaTahT+Msbzf9pxVlRf1DY1nz18MDg2XWEvQG4VObx2dMtr4vn/6dMP/Mc3f
  QjNfOlTUoai5h8riWFUBRwoLH9vZOfDMBCDTkvF8rrbWNjZi1EhHR4ePL+8bEqi4Vf6rh4aGWBCf
  iMGg37J1O2eLkIqblWPmuNHb2+vvv5pbz1I6mpOTw8oGAF6bMMBrmzHw2kQAXptQmJHXpp80/EP6
  JvUubZv7N/fW9uuGWW150dzSeunKtWCc3fY+hYZFhkWcfvb8BWssjux8FaXS3aNTzvIvx9kU9VSz
  qgKOHD8RRFNzyUcsBL0tSyvbtLQ0NmJUSmTkaZ6ZGMmYfufk5LIIPpGXxa8cnVx45vA20/fSmlb2
  OD4+vm79Bm75CTVRQkIiKxsAeG3CAK9txsBrEwF4bUJhRl4bsbdEq1oDgqSZd6gsnlWVI52dXVGa
  mKCQMInTZOYKORkRefpcWVk5ayaOvOyr/WmCgzqXcJI08/7mXuCYXsdqC3jR0NDAeQoFmaJoerdl
  6/aJCZPZOTgDXr0qWeLA/C9uoqz42PETM5vLnj9/gbM5SMWdOXOOFW867Ni5i9vXCdREEZGnWMEA
  wGsTBnhtMwZemwjAaxMK8/LaHndX/lKMpTR1V420C34zcemrvnpWW44MDg4mp9zCZtI3oqa4dOVa
  fUMDayCOjBsm5mfvUbOnHPXl9uLrrLaAI9roGCxqg75VlCg6Ojk/e8b7TAOejI2Nbdu+g/PjQA3r
  4ure2NjEgvhoenv7fP1W8Ex+jGZBWVkZi8B0CI+I5NatVNCuXXsoKWJlA7MHXpsgwGubMfDaRABe
  m1CYl9c2btD93f31qj3EihQ15x+zdowqseRHp9NlZecajyeTGE/mpqCQ8LiEpN6+PtY0fAmuuKHm
  Ea5d8MNYq8fdlay2gBcDAwNrAtdxPqMKMlFNz33PsKGjUlJSbvKcyBpFiXFcXAKL4KO5e+8e5yeX
  4tyxc/f4+DiLwHRITEzi5rVRp6xY6d/RoYYEG8wK8NoEAV7bjIHXJgLw2oTCvLw24ujrBNUe2Tat
  72jmHS9PYrXlCz1jr0pKT5+9YLYL3EJORoSGRaZnPBgbG2ONwpeXvXU/S1yq2t2jJM3cf0jfqDOo
  eXuamDzKy4PRBn2kaJ7t4bmsra2djR410tHRsczbl2dGQaKp88ZNm0dHR1kQH4FON7F33wFu/pFR
  9K5ITTXJM/sKCgu5tZXRUqmoxFdHgAGvTRDgtc0YeG0iAK9NKMzOa6sYaPqNRPUeZUXSLviNhCUK
  Lvxpb++IiUsMCgkztwVuwaHh585fKi1T7Ar/Uf34/87cpubdoyTNnNCKFFZhwJHDh49yTtchkxZN
  8hISlfnWhxunTp/hmY+RKAmnVPzZ80/Yn1tVVb3U0Zln9k5ZlrePX3d3N4vApKitq5NUR1YttrTO
  yspmZQOzB16bIMBrmzHw2kQAXptQmJ3XRlg+PKB2P2Le39/f0Mf9TtI3jI2N5zx8FB55JsQ87icN
  DYukmian3OpSNLvYVxKt7jWbFtELf5q4tHaojVUY8KKmtpbz5AkydVEKt2XLtpGRETaG1Mjz5y84
  21ik6bziEw7Uv3L1OmdDkIo7e870bkUwQumur99ybu86ekzOnb/AygZmD7w2QYDXNmPgtYkAvDah
  MEevTVOfbaGZ904ary5p5qwuUniyW1ffEKWNDQoJV/ECN6pacGj4mbMXip69mNArubHxTmvRj+Ns
  1Lxgk6SZa/3wIF7l/NFqozmn65Cpy256EVZR0TM2htSIXq/fsnUbz+ksiXIYbx+/rq4uFsQHGRwc
  XL1mLc8IKTxHJ5fiV69YBKbGyMjI1q3bubUYFbR+w0YaSKx4YN7AaxMEeG0zBl6bCMBrEwpz9Nq6
  xgb+KMVTzefHk7QLv4j+6nr9A1ZnhRgdHcvLLzx95rwqT3CbXrUXmZp2t7NL4c0ydcPt//LmMpUP
  aZJ2QWzjQ1ZnwIuhoWH/gDU4rA36VFla2wYHh7JhpFJSU9M429CUh9PDePvjTkN7+PAR5Tw8U3ea
  3G/bvtNgMLAITJDjJ4K49Sn1jruHV01NDSsbmDfw2gQBXtuMgdcmAvDahMIcvTZixdNTFlFfSjN5
  lUk7/7eTnJ73Kj+H6+zsunX7zs/NKaljZYoybhqN0sRUVVWzSirHqF43P3uP+sezZv6f3PLpHh9k
  1Qa8yM7Joak/z9k/pA7Z2C1ZtsynqamJjSQ10tLS6uO7nLMTTenx7t17v/WWz0mD4djxE/SXJf9c
  VtGEO+3OXRaBaXLp8hWeaTZ10P376axsYN7AaxMEeG0zBl6bCMBrEwoz9doetBd/L3qRNJlXnzTz
  /+7+OhHsCXr8ampqY+MTQ05ObbqUWFcmpJCTEUEhYZeuXHv2/KVSl41K2FF8Xf17oklRX65+Zqpn
  AJku9IF96PARzuk6pBrRyFH9DQlhYRE8szISpeIOS53KKypYBN9AU1MT5Tw883YbW3tf3+Xt7aZ9
  /+z9++k8v12gwRMWHsHKBuYNvDZBgNc2Y+C1iQC8NqEwU69t3KD7/9I3modDMcf+0ZFxwwSruaLo
  9fry8oro2PiQkxEm57gZY754+VpBweOhYcXunZBwsSb9l2IWWUQvlPa7yqRd8MtxNkU9yq8iNDdq
  amocnVx4Tv0hNcnG1n7tug3Dwrww5eBlcTH/B4Qy5AsXLrIIvoHomFgra35TbRJFderUaVa8yVJX
  V+fs4satTykp9fbx6+npYcUDMwZemyDAa5sxynhtkfDafgF4bUJhpl4bcaHm/ndUf76VUVFzt7y8
  YvhalAdgQq+vrKpKSLoRFnHaJBy3kJMRoWGRV65pnhY9FyppzGh/8avxdiq/D8GoqDlf5eybFGYM
  mw+Xr1ylubjkMxWCPlLGpDE/v4CNJzUyMjKyheNp+kZRcf4Ba3p6e1kQ7zA0NLRx02aeURn72nRv
  RXjD2NgYtS3PXNHG1j4jM5MVD8wYeG2CAK9txijitUVEnsIYfht4bUJhvl5b51j/n9z0ttCag922
  8IuYRedqxDpCxWAwNDQ03rl7/8y5C0EhYcGhwl1XatwuGh55JiHpRtnr8tHRURa6GFQMtPzLFC+z
  WJtJ0i5IaspjNQe8oEw+YPUaziYCpDJRLnf8RBAbUiolJeUm/8fExtb+4cNHLIJ3ePbsOedT5KgF
  tm/fOTb2LafImQShoSd5fsdAWcqRo8dY2cCMgdcmCPDaZgx/r22xpU14RCTG8NvAaxMK8/XaiO3F
  1y2i5kizelVKu+BX4mxuNj9mNReJ3r6+p0XPY+MSwyPPBIWEhSh9f4Jxr6hxIVt27sPmllYB3x3N
  I91/d2+dRdRcaUerUpr5f3EnYHhCiNPxzIrs7BwYbdBniubcNPOur29go0qNtLe3e/v48cwuSJQk
  Hzp8lEXwDiF83SKSja19atodVryJc+v27cWW1pIKyicaOe4eXk3Nzax4YK7AaxMEeG0zRgmvzTo4
  OBRj+G3gtQmFWXttFQPNv57gIE3s1SrNvJ8lLs3qEHR/h8FgaGtrf5SXHxObEHn6XMjJCM6m25TF
  djIiLOL0lWua9IwHtbV1wn4/3zU+8L8zt1lozMNoI2nmBVUks8oDjuzdd4DzeU+QKkWTsOiYWDaq
  VEp4RKSlFVdva8rE9PCqr69nEbxFa2ubL9/bUaksH9/l6sgViZfFxZzPqaRnJCEhkRUPzBV4bYIA
  r23GKLKH9OChwxjDbwOvTSjM2msjluYdN5ddeCTN/H+e4in4AfN6vb6js/Np0bOUW6kXLl0Nizht
  3GEaMn1omsQgm7HoRxnXr9EPp9+fOXcxLj4x91FeQ2Pj6KjQ66eG9WM2Dw+Zy3pMknb+7yW7No6o
  JIUzIcrLK1xc3XlOmCC1iiZ8gWvXDw+p+YaE5y9eUE15Jskkaxvb2Lg4FsFbpKbd4byojebZkaZ/
  K8Ibent7V6z052xW+ges7u3rYxEAswRemyDAa5sxinhte/buwxh+G3htQmHuXltm+8tfilksTe9V
  LM28f3PL5/VAE6u/2IyMjjY2NhU9e37n7v3rmpiz5y+dDD8VHBr+RkYD7gMenPH/Ndpqb/+rU2fO
  X7kWdePm7bz8wqrqmoGBQYPBwEoVmHGDzrMw1Fy2jhoVNce/6CyrP+DI5ctXOa/TgdQqSh1JHzhc
  TAWMjY1t2bqN8zpQG1v7des3DA0NsSCmoUn21u07eE6yqXOXODi+elXCIlAFe/bu5+xXUpfdvpXK
  igdmCbw2QYDXNmNqamrc+XptNIa3bd+h0+lYBABem2CYu9c2bpiY3o5nNkvbSJp5/zFtVdlAI2sC
  E4FeHL19fU1NzSWlrx/l5afduZeYnKKNjrt85fq5C5dPnzkfHnkmLOK00WKj35AiT587e/7SxctX
  r2ti4hKSbt1Oy8rOefGyuK6+obOza2zcxI5wHjNMeD8OM4tbR9/ST+Jsn/fWsCYAvOjr61u+YiUW
  tUGzJZoNHz123CS+0pgxyTdSOLszJHpInz4tYhFM86qkhPP+R2Oqo45bEd6gjY7h3Js2tvZrAtdJ
  nFNgVsBrEwR4bTOmtrbW3cOL5+zR2sZuw8bNeHO+Dbw2oTB3r4240VzwPTPzLyw08/7tbb/SfhOz
  296F3iYjo6P0hu3vH+jp7e3q6u7o7CR1dnZ19/T09/cPDg4Oj4yo4OuOEf24Z+FJ81rRRtLMcy0I
  Zk0AOHLvfjrP/VOQ6kXZo4ure21tHRthaqStvc3Dcxlnh5pS5dDQkyyCac6du8DZJKIJ/c2bt1jx
  auHVqxL+XzbQWzcl5SaLAJgf8NoEAV7bjKFPec5eG702V/mvVkfrzRbw2oQCXtvXOsPEf8vYZEYn
  zRsVNefPbvm+6nvPscpANEb04y75QWZntEUv/Em83dOeKtYKgBf0Ib1n7z7O6TqketGIunrtGhtk
  KiUiItLSml+GRqI0w9vHr6WlxRhAT3fP8uWreOY5asoS32ZgcGDd+g08cxUS9eYyb5+mJtM45QPM
  OvDaBAFe24xpbGzk/J0TPS9Ozq5VVUgW/gl4bUIBr22KmIbc72jnv5Pqq13TZ7fld5ezVgBC0q8b
  Xpp31Oy8YFLUnKV5xwx4cXOnvLx8qaMzz+m+UTQ5g/iIf+eSbGztA1YH9vT2snGmRp4WFTksdeLc
  vDTHTU1LMwaQkZHJ2SWn0k+fUeeRmufP814hSKL2DA4JZREAMwNemyDAa5sx7e1tXl7eVCNJHWXV
  YkvrwsJCDOM3wGsTCnhtU4zqx//LvXUWGnO0234vyTm19SlrCCAYTSNd//hghxndOvpG2oW/HGtV
  ACNYCc5fuMhzlvlG3j5+fstXQhzk5OyqiN1mZW2XnZPLxpka0el0Gzdt5rwYiorbtn2nMYB9+7ie
  6E+jaKmjy/PnL4ylq4yiZ8+NdXy7ynKLilvi4JiXn8+CAJ/IwMBAV1cX+w9TA16bIMBrmzE9PT3L
  vH35e20J8YkYxm+A1yYU8NoY1+uzvqNdKE34zUGaeb8aZ3u97gFrCCAMZf2Nf3VntTkabaSoObaP
  DrOGAByhedLyFats+B7WZmO7xD9gTWNjE801O4DMUBfHJyTyX7BDokL37T/IhppKuXnzNmermrIa
  J2e3iorK2to6VzcPnkkOTeW3bNmm1+tZ5dXF8PBwQMAazkkjiV6/9BJuaDD5E3X5U1VdvW37zm3b
  d/T397M/MingtQkCvLYZMzQ07OO7nPNrkz6J9u7dj2H8BnhtQgGvjTE4MfpX9wItzOpC0jfSLvhh
  rNWx14mTX+MhEYXcztJ/c8vbHLeOTuuXYhZnd5SwtgAcuXv3nrWNPeelHPQhHR0dwyIA8tPa2urN
  /ZtnEpXo6upRUVHB4lAjzc3NPr5+nN1qeoKuXr2m1UZztvmouNS0O6zmauTCxUucm9Qoq6mrXXcO
  DuJmvY+Fcsvbt1M9PJdRfy22tI6IPGWKtx7DaxMEeG0zRqfT+fqt4Dy7mD7p0re9vZ0FYfbAaxMK
  eG3/xNW6zOltpGa5uk27kOru8zi8XzfMmgMox6Wa9J8mOJip80vSzFuce8AwaXoTZVOHJkk7d+3m
  +fFMojmZm7tHVVU1CwJw4eTJcEWWttGE7Oq16ywIlRISEsq5bekh8vFdTtkazyyd0hsfH7/W1lZW
  bTXy+PETzt7HG9GTcvr0GVM0jPhTU1Oz/8AhGpDGDJ/6i35z+3aqySV+8NoEAV7bjNHr9f4Bazh/
  20SPDE1cU9PuYCQbgdcmFPDa/okxg+4f0s3vQtJ/0kKLqDn/J3Nr5SC70QzwZ1Sv2/zy8ve0Cy3M
  8LIOpoW/Em9X2K3mlS/CUlpaxv9WBJrrU5rEIgC8ePr0KTU+fxOBkooVK1f19ZnkDq+P5PnzF8ac
  n6eoRM6FWlrZhoVHsDqrlKGhIf+A1ZzzRqOMhlF0TCyylw8wOjqWkJDo7uFFnyN2b7Ue/Yezi9uL
  FyZ2kiC8NkGA1zZjDAbDho2b+L8zracPNBgdHWVxmDfw2oQCXtsvcKvlyffMc13bG2nm/etb3vfa
  nrMWARxpGumyfXh4ejmbGQ/CqDnej8OxnVkRTp06w3N+aRTNBnJUfV6+mIyNjW3atIX/hNjoINy/
  f5/FoUaGhoc3b9nKc5qriOzsl74sLmZ1Vi8XL13m/1Y0ih4WekKvR2mwuu29lJSUbtu+08rall4p
  kqYjWVnbBaxe095hStvK4LUJAry2z2Hf/gOKfPxRoXfv3sNgJuC1CQW8tl9AP2n4Kme/+e7dM0oz
  70dx1gdLY8cNE6xdgPzca332Z7d9zXhZ5bS0C34rybFqUM2bkoSlvaPD128FZ/OFilu1KqCnp4cF
  ATiSmJRMiZakRziICqW5uE6nY3GokcTEJHV7bVS7rdu2j4yMsAqrl5qaGmcXN1s73itAjbKb3ht1
  5crViQl1XkAxM9rbOy5cuOTs4vrhN5ille3hI8fGx8fZPxMeeG2CAK/tcwgLj1Dk44/mkytWrGpp
  QQYBr00s4LVJKeyu+Em87dT5ZRIXwKykXWChmfdV9t7qwTbWLkA2RvTj+0qjfxRrZe4mLylqzs5X
  UaxdAF/u3LnL33mhEi9euswiAHxpbGz0Wub93iUhsooySYelTuXl5SwONdLW1ubppUDbchNN4lNS
  brHaqp2jx47zfze+kXF1W0TkqYGBARaQGdPX15eQmOTrt5x65GOeL2sb+yiN1lQyQHhtggCv7XO4
  eu26Ui9MKnfP3n1DQ+Z+qwy8NqGA1/YevJ+EU84vdQHMUJq5f3JzWULjI9YuQAbKBprmZ++eupTD
  zO1dknbBH9/0ahvtZU0DOKLX67ds3W7F96tIyiicnF0rKipZEIA7J4KCFZkT07TszNlzLAiVcjIs
  3FI5g0ZWUWa4zNu3o6ODVVXtPHnylF5Wbx8HxllUOj2nGzZufv36NYvJ/BgfH8/IeBC4dj29PT5+
  /TU13RIHx9yHpjGPhdcmCPDaPoebN29ZWin22WdtY3f48NHeHrNOJeC1CQW8tvdQNdj6s0THqbVd
  Ei/ADKWZ/73oxV6FoU0j3ax1wCyhM+hPVaX+bpIzjF0mzbzwSnNZKCEaL18WO3K/FYHmAXv27tPr
  sTdKMR4/fsx517BRU3s9VvqrJrV4L0+LnlFNOT9TfESz6oiISFZPM2BsbHzL1m0885b3ysra1tXN
  I+3OXXPLZ0ZHR3Nzc3fs2EXvjRn0Av2TZd6+dXV17McJDLw2QYDX9jnk5OTwbL13RaOa3tiVlVUs
  IPMDXptQwGt7P7teaSyizPvkrDfSLrS4PudPb/nENOTgxPrZoqS/fmH2nqnLRs33vtFflGbe395b
  OziBK4SU4fSZs/znRjQPSE/PYBEAJRgYGFjHd0L2RjQbvqfqGxJGR8c2btqiSNvKqmkjwPHFi5es
  nubBnbv3rG3sFXdOKSenGA4cPPy6vNwcspqent60tDvrN2yiWn/OozTlKG3fKf4mXHhtggCv7XN4
  9vw5jWFl35b0unBz94yOjlH3V3rfBLw2oYDX9n66xwf+PHXF1M4+iSNgttLM/yL6K+f8E+UDzayN
  wIwYnBg9Whb/O1PL2WDmvtHC70cvSm19ytoI8KWjs5PmeTTbk3x2yirjyqbubiyYVRiNNprSLUnv
  cBDNAnfs3K3uCxaTkpIV3Eojk4xLBsbGxlglzYOhoeHAtetFcE4pg6UucHZ2PXP2XFubKV2y+fHQ
  a6GlpTUqSrtyVQBVlpr98/N2+jmnTp8RfBk1vDZBgNf2OdTV1/OfUr4rCoCGt9/ylZcvX6mpqRk1
  p88seG1CAa/tG0loyvti2gV4xxcwWy20iJrzu0nOh8visf5oZqS2PP3bu4FTl41iOdvbiprjXhjC
  2ghw58aNFP45JH0wq/7ELpOgvqHBxdWd/1fQVKKjk0tx8SsWhxppbW318FymeMoxu6Lshd4YrIbm
  xN2796juktZQSjSo6BXq4+t3PUrT1KSeb0D7+wdycx+Ghp509/Ci1p7FHe70wqGPudTUVJGzQXht
  ggCv7XMYGBgMXLtOhG8mSPQOoUHusNRp85Zt165dz8vLa2xsVP21zvDahAJe2zcyMalf8ugoztJ6
  RwstNPP/7t7am82P8Uh9PK8HmtwKgn8QYwmXTSrtgt9LdqkZxC3dyjAyMrJ123bOsyJjLlFaVsaC
  AMqh1+uVumbR0tr29JmzLA6VEhJyUhyD5vNFOaGH5zK1Lqf6MIODg+s3bLSyFiKBNMq4cIN6JDQ0
  7MXLlzqdjsVqavT19T1+8iQy8rSf3wqqF6VtcvhN1Fyubh4i+/vw2gQBXttnsnvPXqE++IxWO/Wp
  w1Ind0+vgNWBBw8ePnPmXEJCYuaDB/kFBc+ePXv1quT16/LyioqKys+CfoDi29XhtQkFvLYPUTHQ
  /NtJTthJ+h5p5n0vetHC7D05nSWsscA3UDfUseHFxZ8mOEz7tlgm+Y6088JwJYJyvHjx0s6O95om
  moTt2Lnb3LahCUtObq79EgVOV6EEw1vt11k+fvyEc/Isq2g+HW5OtyJISE/PsLVT4C6RD4ueI0sr
  2yVLHbdt35GYlFRdXTMyMsIiFpjR0dHWtrb8/IJTp85Q6mushY2tvIfiWVnbrQlc29Ep6DsHXpsg
  wGv7TM6cOSfIujaJ6OGi1jbeskKDn3p5saU1if6EHj0nZ1dnFzcXV/fPEf0cmlMp+0zBaxMKeG3f
  wvHyxKkdfxJ3AJrS1JbSH8RaOeWfKOox39tePkDHWP+B0pg/SHadctlwre17pZn7vzK3jurHWZMB
  7oSeDOM5pzSKpjU3b8FgFYWhoWHKdalTJN3EQTTZvXlTzSNhbGxsw8ZNirTtrIuylKWOzkVFz1jd
  zA+dTrdn7z6hlra9EfUOPU2kJQ5OmzdvvXr12rNnz+nRFir5oQywsbHpwYOsc+cvbNu+g/JSY8bL
  8wGhz7vDR46Oj4s464DXJgjw2j6T1NQ0Mb22D2jahpty4j5TixZb0SsOXht4A7y2b2FgYuRv762z
  0MyTegTQG2nm/Xq8vWdhyJOeStZqZk/TSNeB0tg/veUzNXK0WMv2DdIu+FGc9cPOUtZqgDstLS3e
  Pn6cjQCai0xPK7tYEEAAaJLE33IlUaa3ddsO09379jEkJ9+gakoqboqiifvGTVvU3VnfSmlpqaOz
  C73EJI0jlKinLK1slzo6+/j67d134HqUJjf3YXV1zdDQEKsGF2iodHZ2VlRUFhQU3rx5+8yZs+vW
  bXB186AI6W1DQfI0ld4WPY/R0TECpoXw2gQBXttn8vr1a8FfkvKJRs6DLHht4J+A1/btZLS//FGs
  FRyTD4kaJ2rOj+JsbB8eetBerJ9U89VyH6ZqsHXby6t/cMN9ei0bdh9/UFFfrnt+gTUcUIKUlJv8
  XQD6SD51+gyLAIhBVXW1s4sb/8kxZZWUW7548ZLFoUaampqXefuqYGkbvStu3rrNamXGnDt/gWce
  PmNNL9NYMu272VDfuXt4rQlcu2vXnpNhEdromIyMzFevXjU1NVGG39vXNzg4ODo6ShnaRyZL9NfG
  x8eHhof7+vq6urpaW1sbGxsrK6uePXt25+69S5evHDp0ZMPGTStW+ru6eVAMiy2tKQZ6CigqpSy2
  NzK+dh4+esQqIwzw2gQBXttn0tvb6x+w2jztNho58NrA28Br+yi2vLxiocElCd+macfti5jF/ztz
  29W6zO5xhc+G5MmEQZ/V8WpZ4cnfSnKEy/ZR0sz7z3cDesYHWQsC7lCmtGHjZs4WAGURSx2dnz9/
  wYIAYmCYnNx/4BB/45VEU7Tw8AgWh0oJCg5RpG1nUfSi8PbxbW5uYVUyY7q7u/0D1vBMY2ZFRt+N
  xqFR9HuSw9Tat+Wr1wRu3LRlx85d+w8cPH48KCws4uzZc+fOXzh/4eLFi5cuXbpMv54/f/HsufNn
  zp47febsybDwo0eP79m7f/OWbWsC1/ktX+nm7klFGH/mm1Kmf28vZr5NsXn7+NXX17NOFQN4bYIA
  r+3zCTb9T72ZCV4bkACv7aPo0w3/7b21Ux6KxC+A3qupjZPz/81tvx3F18v6G1kjqpTOsf4rtRn/
  O3PL92Mtp4/2w/rHj5B24S/HWme0q3kxi/g8efKU87SeRJ/9mzZvoXkACwIIQ3pGJs+Z2RtRmrHM
  21fdV1s+fVpk6uvaKGsKCT3J6mP2PMrLV+Q6kVkXVYEeQBqc074YOyycZDwv/OeS/Kc1/QX6myT6
  J/Rv6SeYYlNYWdvt2LlrcFCgL/zgtQkCvLbP50bKTaqXpKbmIBo58NrA28Br+1gedZX9JM4GO0k/
  Qdr5FlFzfjXBflHOviu1Ga2jPawpVcHQxFh6+/PlTyP/OMVz6qZauGyfpKg5O15dZ00JFIIyZ5pn
  Sz4v5RZ9Ht+4cZNFAESit7dvxUp/RSbHNCNMSr7B4lAjlM9v2LiZ58R31kX5P5ajvoEyijNnz/F/
  f0KzK/o8On36rF6vZ/2qNPDaBAFe2+dTWVnl5Oxqii78ZwpeG5AAr+0T2FsSjUsSPlnaBVPrATXz
  fv+Gm3thyI3mgrbRXtagJsiwfqywu2JH8fW/SFv1HardVNWwXfQTpZn7D+kbhyZGWZsCJWhubnZz
  9+RsrExPKL1bWrANTVAuXb7CM8F4I5oRbtq8ZXh4hMWhRuLjE0zXa6PIN2/ZOjw8zCoDvv66r69v
  w8ZNJu2fQnb2DtSDaWl3BEkR4bUJAry2z0en023ctMXUF3TPQPDagAR4bZ/A4MTo/8zYgp2kM5R2
  4dTiL+2CP07xdMw7frUus26o3VQeyl7d0L225+ueX/iLOwE/iLWarggsthlJu+BX4u0KustZywKF
  SEhI5L8og0oMDgllEQDxKC0tc3J2VWRpGxVaVFTE4lAjLS0tbu6eJvolP03ZE5OSWU3Az3ldXu7q
  5mGGyaSaRN1HnUivPtapigKvTRDgtc0KiYlJ/OeZigteG5AAr+3TeN5b8xsJS7CT9LM0vbfUQjPv
  NxMd//HBjp3FUXdbn7WOCLfDtE83/LSnKqzy5tK8o//iptfPV7HNw17Rz5Jm7sHSONbEQCFGR0c3
  bOC9IoPyB9Ljx09YEEA8aJ60a/cezgPDKJqRBwWp2Yeltg0OCeWZv82WKA/09FrW1tbGagLe4n56
  uvHNJmk0yIRkZW0XuHZdR0cH61TlgNcmCPDaZoW6unpPL29Fvr1TUPDagAR4bZ9MWOWt70nsA2hm
  mtpeOtci6ksL7cLfTXb5Mmvn1pdXExofFffVDU4osJlIZ9DXDLWlt7888TppyaMjf3bb74uY6esO
  ooz3isJi+2xp5i7I3juqH2ctDhTi8eMn/PNDG1v79Rs2joxi77DQ3E9PV+SL6ClDZ5l3Q6Oa79J5
  /OQJ50R6VkRz6DC1XxQ7YwyGyYuXLtMjA7vNpEU9ePTo8bGxMdavCgGvTRDgtc0Whw4dUeTbOwUF
  rw1IgNf2yegnDa4FwdhJOsua2mE6b8rY0sz7lXj7P7u9fFHu/h3F1y/XZmS2v6wdah+aGKOWZ30w
  G4zqdW2jvY+7K2Ibco+UxbsXhPz13cDfTnKe8tSmwpja7ioNEvocaRf8ixTPmkEsjlCeoCAF7mKn
  EuPjE1gEQFTaOzpWrPRXZFvcYkubxMQkFocaGR0bW8d3+vv5orSfkv+iomesDuAdxsfHT5wI5pmZ
  Q3KIejA6JlbZXBFemyDAa5stcnMfwmvjD7w2oYDXNhO6xgb+8k7AlB0jcROgWZHRdzMueYua+72Y
  xb+WsORPb/n8z4wtdo+OrHx6ek+J9mz1ncSmvPS2FwXd5a/66isHW+qHOxqGOxtHuqY03Em/rxlq
  e93f+LSn6kFH8a2Wx1frMo++Tlj3/IJL/om5Wbv+Y5r/z5KcfhhnPXW5wXUqaHp/KPw1ubTwR7HW
  t1uwf1B5mpqa3D28OK/qp+I8PJc1NDSwIIDARJ46zd+KJU2tfFy/UfGlJbISn5BoWqYMTdY3btqs
  7k75fAYHB/fs2bfY0lrSepAJiT6kHJY65eY+ZJ2qBPDaBAFe22wxPDy8Zcs2s7Lb4LUBCfDaZkhh
  d8VvJjpgXyEPaRdOWWCa+VPmZtScX/TFptr/uzGLfhhn8xsJDr+Z6PizJKffSnKi3/w0celP4u2+
  iFn8nehFU3/N+BPYP5+y8NhPwNF7XPQdzfwDpbHs4QGKEhMTq8iitmPHTrAIgNi8KimRdB8fGZdQ
  5ecXsDjUSFNTk4fnMs5O9+eIntykZNyK8O1Qnrxp8xZFTGpoVkRPJXXflavXFEwX4bUJAry2WSQ3
  N5fqyHNUKyt4bUACvLaZc7oq7TtTTg3MGkG0cNqVe0voGkEUNWdRzr5xwwR7coByDAwOrl23nv8O
  QSqxoKCQBQHEZnR0dPuOXYp8EU3TtRPBIQbDbB4XIBonTgSbiiNDGaC7h1dLSwsLHXyQltbWTZu3
  8EzRodkSPZJu7p5pd+7o9XrWnUoAr00Q4LXNIhMTE7t37zWfpW3w2oAEeG0zh4aU9+PwqaVSEmcB
  gqA30s7/V7d8GobVOYcwOQoKCvgbbfR5H7h2XX9/PwsCCE9Kyk1FZsaUZLq4ujeq+oaEgoJCU1nX
  Rnl4SOhJFjf4CNrbO7Zs3Y7NpCYk43K2zZu3lldUsF5UDnhtggCvbXYpKiqigW0qH3yfKXhtQAK8
  ts+ia3zgb+4Gwm6DoPdLu+DHcTZ3WnGutigcPnKM5taSz0i5RSVej9KwCIAp0NHR4e3jp8jMmEaL
  RqNlcaiR4eHhdes3KnL7xCeJEn7Kjh4/wSGbnwY9Ozt27uKZqEMzFuWiSx2dL1++Ojg4yPpPUeC1
  CQK8tlnn3LkL/CefigheG5AAr+1zKemr/4Mbbhba+VKXAYLMXNqF39UuiKy6zR4VoDS1tbX8b0Wg
  tMHJ2bWuro4FAUyEiMhISysFZsY0O1y7dr26V0HGxyeKn3VMXVWxYRNuRZgBfX39x08E0UjmaZpA
  nyT6HKRncPOWrS9fFrNuEwB4bYIAr23WGRgY2LjJLE60hNcGJMBrmwXutj371Xi76aP637EbIMhs
  FTV33fML7CEBAhAbG8dz+mgUTa0OHT6in1DyEBwwA549e07dp4hZYGNrn5efz+JQIw2NjR5eot+Q
  QE9ucvINFjH4RMbHxy9fvkpdLP4CRjMUfQ46u7hFR8cMDQ2xDhMDeG2CAK9NDkpLy1zdPAT/4Pt8
  wWsDEuC1zQ6nq9K+i0stIeiNouYuztk/oh9nTwhQmuHh4YDVgZwTP8oZSFnZOSwIYDqMjY1tVuiq
  /ml/9iiLQ6UcF/uGBHpRUO7X1NTEwgWfjsFgSE27Q7mlIg8R9F4Z3c89e/aJcDrbu8BrEwR4bTKR
  mpZmrO/b1VeZ4LUBCfDaZo2NLy5ZRM2VOg4QZIaKmvs3dwPbRnvZswEEICcn196e9zIlympW+QcI
  chQO+FQSEpTZ6kgTcTd3z+rqahaHGnny5KnI+Qb1e3BwKIsVfAavy8s3btpM7cn53QtJRO1P2aCn
  17KbN28JuzMaXpsgwGuTj8TEJKqvit+H8NqABHhts8aYQWf78JCFBnYbZN7SzP+jG+6l/Q3swQAC
  oNfrjxxV4FYE+vS9cuUaCwKYGs3NzW7unorMiWnkqPuGhIHBwXXrNwi74olyoadFRSxW8Hn09/dG
  RJ6ysbXHAjdFRG8w+uxb4uB4/ESQ4CeHwmsTBHhtshITG0fvQ5G/bfocwWsDEuC1zSbto73/5d5a
  XEsKma+mLx5NbX3KHgkgBrV1dU7OrpxNE1s7BycX14qKShYEMDVo2hQccpK/RUuiibh/wOr+ATXf
  kBAdE2slpPlCE/SNGzdjOeosYjAYsrNzVq4KoIRExQs6RBM1tTHb3LN3/8uXL/V60Y8NhdcmCPDa
  5CY2No6GOn3QS5pCBYLXBiTAa5tlKgdb/uy2L1a3QeYo7YIfxCy+WHOfPQxAGK5evcbfMaES9+zd
  Z5g0sCCACZKfX8A593sjSj8yMx+wONRIU3Ozq5uHgM4LTdDj4xNYlGD26OrqOnP2HD1QPFMgsxU1
  Mr1Dtm3fQS8x8V02I/DaBAFeGwceZGVTrRX5Mk9WwWsDEuC1zT7Pemr+6Ia7hXa+1ImAIDVr4RfR
  C0MrUthjAIShr69v9ZpA/tkdlXj/fjoLApgmo6OjgWvXK/LlM03BDxw4ZDCo1qulqp04EcQzo/sY
  UZ7v5u7Z3NzCogSzCqUiz54927J16tYR/u9kMxE1LL091q7bkJGZOT5uShc0wWsTBHhtfKiurtm8
  ZRs1NbWApE1MV/DagAR4bbLwoKP4Z4lLLTTz3vEjIEiVWkijfdcrDXsAgEjk5j7kn9TRzMnXb0V3
  dw8LApgscXEJivhBlHA6ObtWVlWxONRIXn6+saZvV1xZUV+HhJ7EjFlWRkZG7t27H7A60MraVpW7
  qBQRPUdGl80/YM3t26mmuAkaXpsgwGvjBj2nFy5ecnZ2paEo1EfhjAWvDUiA1yYXt1qe/GqcrYV2
  wTuuBASpTpq5q4vOTn6Nl6yI7Nt/gCYxks9FuUWfu+cvXGQRAFOmtrbOw9NLka+daRRdunSZxaFG
  FFw2+F5RquOw1OnJkycsPiAn/f39SUk3/JavoIwIjtvniMYtvSuWODht2brtzt17PT2megc6vDZB
  gNfGExp+Za9fHzp8hD59+H8xPOuikQOvDbwNvDYZ0dRn/yjOxkK7UGpMQJCapJnnWRg6bphg4x6I
  RGVllaubB2ejhFIFJ2eXVyUlLAhg4hw6fJS/XUuysbVftSqgr6+PxaFGYuPiF1taSyqulGhqvm79
  xrGxMRYckJ/u7p6kpOTVa6bWuKlmZQcfUVvRiKUcz9nF7fiJoCdPnlKGyZrVNIHXJgjw2vhjmDTk
  FxRu2brd+CZU5Ou9WRG8NiABXpu8RFalfhE9dWa81J6AIHVIM9cy98DQxCgb8UAwFLkVgT7gafqu
  4pO2zA3KAHlO2t6Ick6acGdkZrI41Eh9fYO7hzLLBt8VTZfjExJZZIAjAwMD9+6nb96ybYmDI/UC
  jQeYbt8k42uBPtdsbO1XrPS/fOVqXX29qdx+8GHgtQkCvDalGB4ZycvLO3zkGH0sUhfQM25yb0IK
  G14beBt4bbITUpEybbdhdRukOk0Zbft7x4fYWAeC0dfXR6kI/zSepu937+I6WvUwdb1G4FpFtrlZ
  2djt3bvf1JerfJijx47zN8TfFb0oPDy8mpqaWFiAOyMjI89fvAiPiFzm7UuPG40KOG5vy276w4We
  FU/PZceOncjNfdTba6rbRd8LvDZBgNemLAaDoa6uPiY2bk3g2qWOztQX1jZ2pvIyhNcGJMBr48HJ
  yps/jLWC3QapSpq51g8PDk6MsFEOxCMjI5O/P0Il+i1f0dbezoIAquDateuK+EE0vaapdlnZaxaH
  GsnPL1DEx5SI+vdEUDCLCSgKZd23bqfu3rPX0cmF+oXSGP5fmYgjqvuUxWZj5+zitnff/pSUmy0t
  rayl1AW8NkGA1yYIIyMjRc+eR2m0u3btcXZ2pQ9K6hcatCJ8Yn6T4LUBCfDaOBFRefuXYhZhMymk
  EmnmWuce7NcNs/ENxMNg0FNaQpMSySei3KISw8MjWRBALVRX11Ciq8gXyzSizp07z+JQI4ODg4GB
  6xRPHqhzCwoLWUxAAMbHxxsaGpJvpOzes8/dw2uxpbUxyTSV9R0zFlXQ1m4JJYpUX/rV12/5oUNH
  0tLuNDe36HQ61jpqBF6bIMBrE42xsfGW1tb0jMzQ0LDNm7f6+C6nx8T4SqRXBL0VqQ1J9IeKvx7h
  tQEJ8Nr4caoq7fsxi7G6DTJ5Rc21f3RkQIcVbUJTWlpGcw76/KO5CE/Rp3txcTELAqgFg8Fw4MCh
  rxZZSrqbgxYttvLy9mlra2OhqJHomFiqqWTyylOUq6xbv2F4GF+fiIher6+vr7+fnhEcHLpqVYCz
  i5vxxW7MLSVdaaKiihj9Ncqf6Tcenss2btp86fKVgoLCtvY2Mzn9Mzf3IbUAz0/tBQsXb96yFRmy
  hL379i9YuEjSVvKJxrybu0dHRwcrHnyQsbGxlpbWkpKS9PSMCxcv7tixa+VKf29vXzd3z6WOzvRZ
  Ru1ptOFI9ECR6A+NfpzRjPsc0Q95V8afT6KyFn61ODPzgbLPlF4/sXrNWp4TNnperl69hjfJe4HX
  xpXIqtQfxFpaaOdLzQsIMhVdnzNltGHrqPDk5OTSfPHQ4SM8deDgobPnzo+MYHiokKKiZ/v2H5D0
  OB9RuWVlZSwONVLf0ODu4UlTdokBwU00V8atCCYBvV1flZQkJSUfOXpsxYpVDg6ONGyM2Q5lepQK
  SnpWWFGoFDCFbfnzE9DdPbx27Nx1/sLFjMwHDY2NZni7Ttnr14ePHD146LDkBSif6NWKDPldYmLj
  eH7Y0cQpJPSkum/clpXx8fGOjs7KyqonT56mZ2QkJCReuHgp9GTY0aPH9+0/uH3Hzg0bNwWsXuPr
  t4JeMk7OrqSljs4fkKOTC8nZxc3F1d3VzcPN3ZP+oYenl6fXMq9lPsu8fb19/Hx8l9MP9Fu+cvmK
  VQEBa9at37B5y7YdO3fv3LVb8e+b9Xr9+fMX9tPAemewySRKNx48UHg1n7DAa+PN+Zp7P4q1stDA
  boNMTgstNPMc847j1lGTYGJCP6EEuH5UrdAsivWxEqjjnsEPcOTIsQULF1la2fDXV4usXN3cGxob
  WSjAFKAnYnBwsLa2Nj09/cyZc7t271m5KoDyw6k+nbbeJKs5JFYXNxlXglAYxgUmRluQglzi4Lh8
  xcrt23cGBYfExye8ePmyp6eHcmZWPbNEkXes6l+tM4DahLUOR+BTzC7UntSPOp1ubGxseGRkaGio
  f2Cgt7eP3jNEd09PV3d31/vo7qb/8+f0vqHv5/S/YeDn0A8fHh4eHR0do1fYuM5gUL4r+Y9hTP6/
  CXhtChDX+PCnCUuwug0yKS200Mxf/ezsqF7Np6UAAIAiNDY23r+fkZn5gL/S0zOfPHnC4gCmCaU6
  nZ1d1dU1jx8/SU6+ER4RuXXr9lX+q318/FzdPJY4OFpNb1WznN6faLThjB7crMjophkNtTdumnEb
  l8NSJzcPL1+/FQGrA3fu2h0eHhkdE/vw4aPKyqr2jg4zN9cAAACoG3htynC/7cUf3HCz0Mx9x9GA
  IPGkXfA97YLdr7QTk/j+EwAAADABRkdH29raysvLCx8/vnvvXmxs3Nlz54OCQ/btP7h5y1b/gNWe
  Xt7OLm6OTi7GnVMOS52WODiSjOvRJHp7tRr9HfrL9A+dnF1dXN29ffxWrw7cvHnrnj37jh47HhYW
  fu78hejomLt371HRlZVVnZ1dE6q+1gAAAAB4F3htivG8t+bPU5dbRM2R+hoQJJQ0838UZx1ReZsN
  XAAAAACYJpOThomJial9VcPDg4ODnV1djU1NNTW1r8vLi4tfPX1alJdfkJ2dk5mZlZn5ICMjMz09
  g3598CArm/40Nzf34aNHj/IeP35SUlJaW1vb1tbW19c3NDQ0MjJCP1On0+n1euyGAwAAAAh4bUpS
  M9T29/fXW2jmSd0NCBJEmvk/TXCIa3zEhiwAAAAAAAAAAAA+CLw2hWkd7VmQvcci6sup87AkNgcE
  KSvN3N9Pdk1vf8kGKwAAAAAAAAAAAL4NeG3KMzgx6vckcupmUu0CqdkBQUopas7f3A180VvLhikA
  AAAAAAAAAAA+AnhtohBcnvzjOBvYbZAAWmihmWf36HDHWD8bnQAAAAAAAAAAAPg44LUJxK2Wx7+P
  y0khZaWZ/0X0V1teXhkz4MowAAAAAAAAAADgk4HXJhYl/Q3/9f56iyjYbZAS0sz/zYQlV+oy2HAE
  AAAAAAAAAADAJwKvTTi6xwcc845PX06K2xIgjtLM/Q+pKx92lrGBCAAAAAAAAAAAgE8HXpuI6AwT
  B0pjp45vm3Lc3vFEIGh2pV1goZlrmbu/friDDUEAAAAAAAAAAADMCHht4pLe9uLPb/tZRM2ROiMQ
  NIvSzPtJvO2h0rgJg56NPAAAAAAAAAAAAMwUeG1C0zra4/Do6HemNpNiPykkgzTz/kPqisz2Yjbg
  AAAAAAAAAAAA8HnAaxOdiUl9SMWNX4u3w/2k0GxKu8BCO39p3tHmkW421AAAAAAAAAAAAPDZwGsz
  DR52lv3nO/7TdhsWuEGfrai5v55gf7LipmHSwEYYAAAAAAAAAAAAZgN4bSZD+1jfqqenvx+9CAvc
  oJlr+hqE/56+Ma/rNRtYAAAAAAAAAAAAmD3gtZkYt1ue/PvU5VMXJmixwA36REXN/bV4u/0lMcMT
  Y2w8AQAAAAAAAAAAYFaB12Z6tI/1+Red+UHMYgvNfKmZAkHvlXahhWbe/0jfWNhdwYYRAAAAAAAA
  AAAAZABem6mS0lz457eNC9wWSI0VCHpbUXN+Ne7/b+9uY6uq7wCOl8WozMUsWeZQ0bm4bJO92LJl
  xhfGzWWDtrQ+UIi6KVTm3AQm6FwmjKkBk2mYmbrNaN3cg6P3QgsrrTyJFigooFCGtVWgqNXyZJ9o
  a28faMvuuZypY1vm5gF6bz+f/F5Ac9u055xX3/z/5z9pfm28oy8RPj0AAADA8aG1pbED3W2zqh8/
  vaTAG9zMv5/Y+KxY7jcq52xu3hk+NAAAAMDxpLWlvY1Ndd9e9/OgqljgZt6bYNPoBRXfK6pf1TPQ
  Fz4rAAAAwHGmtWWC7v7eoj2rLqiYakupCaY4Z2TJhBnbHn2zqyl8RAAAAIATQmvLHG91Nd1a/djI
  UltKh/HEx2fFxl++dk7V27XhYwEAAACcQFpbptnYVDd27dwRi1Lv6np/hTGZPfH8rOKcC5/6vk2j
  AAAAcBJpbRmoZ6Av3rDhq0/fFixwi+UeG2VMhk08L6s4e1TZ5LtrFu7vbgsfAgAAAOBk0Noy1juH
  ex6tX3nRiluyinOCrYXHBBqTCZOfVZx95pJrbq0uqu/cH954AAAA4OTR2jJcc0/H/a+Unld+Y7DA
  LZ7/L7HGpO3Ecs8oLSjc8uBLh94IbzYAAABwsmltw0JD19t37vjjqLIbUgeVWuOWzpPaMXrq4glX
  bphf1eQABAAAABhatLZh5PV3Dt5Vs/DTFVMVt7Sc4PSD7DNKJ35n04KNTXXhTQUAAACGEq1t2Nnf
  3brg1aUXrZgW5LZ43rFBxwzFyc+K5X5i6XU/ePE31a314Y0EAAAAhh6tbZhq6e18ZPeKL636UVDc
  gsMTvMptSE4sN6s4+6yy62dtf/zlQw3hzQMAAACGKq1tWOs4nIg3VGWvu+v0kgmpjaWWuQ2Ryc+K
  BafHfnHVjHtrF+1xxigAAACkCa2NI/2DA5uaX5m29ZGzl00OilssN2g9x9Yfc0ImWGaYfXpJQfb6
  u+NvVrX1vRPeJAAAACAdaG28pzHR/NDO8oufvn1E6jX8lrmduEle8FhOckaXF86sfnxry+7BI4Ph
  XQEAAADSh9bGsXr6+1bt3zZl86/OKS8M1rjFcixzO44TC96X97HSSd9aO7eofvW+RGt4GwAAAIA0
  pLXxH73V1fTEa2ty1t9z5pJrUntLHaEQ1eSnEtu4EYuu/MrqWfNqY9vbXhsYtJANAAAA0p7Wxn/3
  akfjL19ZeumzP00doTBOdPt/52hiy05evc8uv3lmddG6gzWJ/t7wKgMAAADpT2vjg+ofHHihZde9
  tYsvq5wdrHQL3i/mFIUPNrHxyct1yuKrxqycPmPbo8v3bW3rdegBAAAAZCCtjf/ZwOBAXfubv939
  1BUb5n+y7PqguAWL3XItdnvf5B89UTQ5I0snXrLmjrk1T25oqmvv6wovIgAAAJCJtDY+lMZEc6xh
  /dQXHv7CimkjSwuO1qVgGdfwXO8WzwuW+xVnj1h0xbnlhXlV8x7cuazm0Bu9A4fD6wUAAABkNK2N
  aCT6e7e11hftWf3dTQ+MWTn91JIJ4Rmm8bxjg1SGTTz/H6e1XjG6vHDc+rvvrV307MEdTT3t4aUB
  AAAAhg2tjei193Vtbdn98K6Ka55fMGbl9I8umRQEqeJxqSVvueld35J/SDx4+drRbbOnLr76/Iqp
  Y9fdNbfmL2sObG9MNIeXAAAAABiWtDaOr87Did2d+/7auGney/EJG3/x+RW3pM5VyE3tNs1JLXwb
  yhtO81PbQpO/bbAzNDmnlRSMLr/xm2t/dvv23//htWeqW+tbejvDPxUAAAAY9rQ2Tqju/t669rfK
  GjffV1c6ZcuDl1XODurb0muDsHV0vdjR+nZS1r6Fa9ZSG0Jjyd8h/7SSgvMrpl685scFz903e8ef
  /vx65ZaWXS29HeEfAwAAAPDPtDZOspbejp0djWsP1hTtWX3H356Y9Pz9X6+cPWbl9LPKbjhjyaRT
  Fl+d2n+anbVwbLgL9d0FcUEUS874VJt7d/JS876vJD8QfjL1XeFPGJe1MPnTxiU/8JHFV40snfjx
  pddduPzmS575SX7VvB9ufeSBV8sq9r7w0qE39iVa+pxsAAAAAHwwWhtDzuHB/s7D3c09HfWd+55r
  qitr3PxY/ar5tYtu2/67m1789bWbFuRtmH955Zyvrbn9opXTLlx+83kVU88tLzynvPDsZVNGLZv8
  qWWTRy2bkvx38iujy2/8zFM3fW7FLV9ePfPSZ+/MXn/PxOfuK9zy0Ixtj82tefLhXRXxhqrKgzte
  PtSwv7utva/LgaEAAADAh6G1ka4Gjwz2Dw509fe09HYc7G7b3926L9G6N9HcmGjem2hJ/vdAd1tT
  T3tHX6JvoD/54fDbAAAAAI4brQ0AAAAAoqG1AQAAAEA0tDYAAAAAiIbWBgAAAADR0NoAAAAAIBpa
  GwAAAABEQ2sDAAAAgGhobQAAAAAQDa0NAAAAAKKhtQEAAABANLQ2AAAAAIiG1gYAAAAA0dDaAAAA
  ACAaWhsAAAAARENrAwAAAIBoaG0AAAAAEA2tDQAAAACiobUBAAAAQDS0NgAAAACIhtYGAAAAANHQ
  2gAAAAAgGlobAAAAAERDawMAAACAaGhtAAAAABANrQ0AAAAAoqG1AQAAAEA0tDYAAAAAiIbWBgAA
  AADR0NoAAAAAIBpaGwAAAABEQ2sDAAAAgGhobQAAAAAQDa0NAAAAAKKhtQEAAABANLQ2AAAAAIiG
  1gYAAAAA0dDaAAAAACAKR478Heh4kvD6LmlJAAAAAElFTkSuQmCC`;

export const CHECK_GREEN_BASE64 = `data:image/png;base64,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`;

export const CANCEL_GREY_BASE64 = `data:image/png;base64,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`;

export const CANCEL_RED_BASE64 = `data:image/png;base64,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=`;

export const BLOCK_GREY_BASE64 = `data:image/png;base64,
iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAF
8WlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0w
TXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRh
LyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNi4wLWMwMDIgNzkuMTY0MzUyLCAyMDIwLzAxLzMw
LTE1OjUwOjM4ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3Jn
LzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0i
IiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRw
Oi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMu
YWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNv
bS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9z
VHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjEu
MSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDIwLTEyLTA0VDA4OjU1OjUyKzAxOjAwIiB4
bXA6TW9kaWZ5RGF0ZT0iMjAyMC0xMi0wNFQwOTowMzo1OCswMTowMCIgeG1wOk1ldGFkYXRhRGF0
ZT0iMjAyMC0xMi0wNFQwOTowMzo1OCswMTowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rv
c2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIu
MSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxZjU4OGJhMS00NTNkLTY5NDAtYjE3Ny0xNjNi
Y2M3YWJhNTMiIHhtcE1NOkRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDpiYjhiYmI0
MC02MzIzLThkNDYtOTgyZi1jMWE3YjQ1MzZhNzIiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0i
eG1wLmRpZDo1NDM5ZTZlOC01MWY2LWUyNGYtODY3Ni02NWNhNGViZjIyY2MiPiA8eG1wTU06SGlz
dG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0
YW5jZUlEPSJ4bXAuaWlkOjU0MzllNmU4LTUxZjYtZTI0Zi04Njc2LTY1Y2E0ZWJmMjJjYyIgc3RF
dnQ6d2hlbj0iMjAyMC0xMi0wNFQwODo1NTo1MiswMTowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0i
QWRvYmUgUGhvdG9zaG9wIDIxLjEgKFdpbmRvd3MpIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJz
YXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDoxZjU4OGJhMS00NTNkLTY5NDAtYjE3Ny0x
NjNiY2M3YWJhNTMiIHN0RXZ0OndoZW49IjIwMjAtMTItMDRUMDk6MDM6NTgrMDE6MDAiIHN0RXZ0
OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMS4xIChXaW5kb3dzKSIgc3RFdnQ6Y2hh
bmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+
IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6WqWHuAAAHvklEQVR4
2u1daVMbORDNn9+A8TFjG2f3T6WKZBOKJYQUqQAGfMEajO/tZ2uWgdg6ZqSxZqQPqlDBWNJ7kvpQ
d+vdcrl859vumgfBE+AJ8M0T4AnwzRPgCfDNRgKarb921urND5+D+uE1tW41aPTL1fDhoBI8lsq1
0V6pMn6/X56h7dPP+D/63RCfwWfpbzph4/Cqcfjnp13OIXcEhI3Wl2pQ7xOIEwJwSQCmavR9S3wX
tR4R+rcnYEOrhc3jSi28r9Tq07D+Ajr9Tkt7IeOQyKhPqZ8+EfPVeQLoyLigNjMBupAM6pOOK5Bx
7hwBmDQmj+MhC9B5ZGAMNJZJLWicFZ6AIGyeEvjjXQO/jQga2zP9+0/hCIBgZZOzCvhtRJDAftIl
sHdOAAnYX6QSLtICr6r9pO0LY6Z2kWsC6Gzt0CS0aC7lajCiXfQvrc4BkdqDnk+r9CZqtHJvmb0w
II3qkT47i6uxScaAsdP3XOeOAJrwEQExwnZOBvpadyegu2mOAoyDvuOGFgIImSc5AqEtkabWyw0B
NMHvNNG5ykQj0AmsMbWOKesV2lcSJSAS0EnGlSkBtGV/0mAXSbQP+tvTrKxT9KWqFDC5MKcdeW4l
ARiYCvhM/56a0r9l1WLYAPVmS0UuzFV2QiYE4KwlgTdXAH9BwLd36SSLN5I3kDXSOwG7xyoCSEt5
ltnKsW38wxbwY4voUWX3ygpm4wRA1ZTRdmKC7Mg28NkR+qSqHcmoqEYJoK17KaPnp1XlMvDGXsse
QW/tBJGxZowA6vgY1qKulbJD8H/BYEtqNQMDnq1ijACyNseic3+t6QRdm8FPaqnH5Rp8R5kSQB2e
ic59VW0hj+DHF9o2L6oRAqC/i1Y/05ePig6+aLFpJ4BWf1u0+qHn26hqqoIPwQztCCqqSEivXCkb
jEqtBNBAPmJlCwcSNq/yDj4EM7Sj18Zai7sL6GQYGyUAkQW8o4dtxXHewcfn8PkNR++EN39m65wb
I4AGMBcNIEunWpbgR74j3vELbMjemRohoFINz0LOJNjqHxUV/JhLm+t2AUbxkBdtBBCzD6LVT+2k
yOBHrmzRLkDckXYCeMePyBgpCvgyRugai/pUKwE0uBPe8cM0n28ugB/drPF2ATSoyD2hhQBa/fe8
4wf3ra6AHyNhLnBP9LQRgJhN3pbDpbdL4LNF+Sg4kidaCIBEF2k/NJm2S+Cz/m5ESgmuLlMTQEze
SnR05BL4sWtYQcDB4ZUOAvo8AqKt5hL4MTkwE5wMndQEIOOEd9bRIIYugs/UUZEc6KcmAClBgk4G
LoLPfGMDgXLykJqAUrk64nWC8EEXwWdWcZeHDXLWUhOwV6pMeJ0gic5F8FnY/S0PGyQOpiYAWYjb
OnnreHIJfBbKcsMjANmbqQn4431pa/xkuRIsXQVfhgAsXmMErBg+qCxdBT8zAnhHUBY7wFbwmRDu
8AjY03EE8YQwSy89chF8Nr6ecSG8f1B95nVCQvjSRfBl7ADYUBrsgNqTQA3tuAg+84g+GDfEJFwR
9y6CvyYgGBl3RRDAInP7yUXwWV7ElOeMg5dAhzf0TnAbNnMRfFw5itzR8BKkJgCVTLj3wRqs4byB
vx5zo8u/J1ndC3/WdSU5E0QB9FwCn2lAk0yuJFfChhMTFO/MFfBx1SiKDYoWpRYC6MtORWEpqkFZ
eQWfjf1OIjrui+7QxLlA4j+6AD4b/1igmusNzBKFYUQ5AfT7r0UHXy40MRxoJ0AUhsF2wbDI4MsG
50Jz1E7AOgxDnBlDnzsuKvg1QW4c8//MjOUHYIWLdgHK1BQRfJncOJZBf2EyRemTKDcYuVQ0kHY8
CVo2D9dm8GuC3LhNyRlGkvRoFdyJjiIiASQNkeAmm4FuM/hIOBRVgtmUnmQwTTWY6Sy+ZzP4kH2i
xMSV5rMhQc8YAaRm/VAtR5ZH8GW0nv9z48LmaaalCkQZg0UAHwVG0lYEMEYAaTsnQb2ZIr3f+pV/
HUpoblBKIrdD5uVq6NxrJ0n5h2COJ0Hbp24GXUnwhYvIeMGmUrnWV5UHrDiSlQI3KuYnWfNOeB+e
SckyZMcryoOhjaomKzAiW6JGKic6EwLYSxcLhR2wiBtrFng3rxQrPkpXgsmsbCUNilRTJRJWq2ib
7yjD+qFjlSOU+bu+W1m4lZX/Ui3cusBdgowrW2NY+QkqPSaooIuC3j+tLl2MnaBaLT1OhMlyB0gm
R0a/KvAs4U65au5OCIhkgurWbr6u3z/BQz5poy2YG6Gdqnj3ajzJy23utHw9VNQkdkL8nRdEZCD4
i0i5Xz9N1bp8CwaIQgwOAqHW5evrw/UrTK3U5etlVE1rCXgx1pqpHlX47WmqNTCr/AT8G38ESOcD
DqiLmnb+VjxhArcFfEe6nzDR/RzKSzX3cIy6qDrmbtUjPvCiwpWty5Oqs0XV3Kuaq7lb+YwVLnV0
vCujY8VHBcWrhqq5W/uQG643ccecVlCmEfAoQsUKEX40NU/rnzJ89c4LAWL0KUMGOkItUQMvC6Mv
d495IgyS5MTD6hWkuobHPNeq7BRFp1D5K+v55Po5WwQ4IT8Buj0ydZAuhZw1JA4iexMptGj4Gf+H
sgrIy2JP2g5QaifLRHIjBPjmX9T2BPjmCfAE+OYJ8AT45gkoXPsPpF59PS0k4ykAAAAASUVORK5C
YII=`;

export const GESTURE_BLACK_BASE64 = `data:image/png;base64,
iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAEKElEQVR4Ae3cAWQjSxjA8YdFsFgU
QVEUwSEoiiIUQVEERVEUQRE8FEVxCIrgUBRFUATFoSiKIiiCIAiKICiCIFh87/+448Rd7pvNTLKp
788PIJhdO5ndnf3HsizLsizLsizLsizLspZsBw08YoD3Hx5xgQRWgCp4hvzFFE1E8JC1gyeIox6K
sJboFFNIRgM7CNlrQjx4hmNWC+LRCdaSDT7Qgz4b/CC2YS3oDBLQBawFFTGABNKEx+wgpOhhAlG4
h6fsIHRRxv9VIQov8JAdhDtE+NkuROERDllFdCG/uMJ8J3YJCleMVwga+F1vEIVLZMiKF6xkqxCl
KiyPRRhCFGYowPLYNUTpAZbHykghSgewPFXAAGL//9fTV4iDfYRqC19QQmyXnjm4g68iHOIGfaSQ
ORP08Q17+FRF6EKURkiwbEVcYwJx1Ecdn6I6xMERlilBCzPIkr5jGxvbluMZeI9lOsEY4tEHDrCR
3a3o0pPgERLIB0qffeKtIUtlvEMCG6GIjekRovSELB1jClmRB2xEFYjSDLtwrY4UsmKHyH0vgZ/5
NiBr0keuO3Cc3BK4dA5ZswpyWwei1IBL1SUuOzO0UPnloO/gELeO64YOctm2wwANUYC20hITbhtF
xe+PIAop4k1/MfcM2hIMIY6mqEHb3qY/qftwOPsjaIrwDHE0QgmuPUEUbjZ58m1AW2vF+wsuIAqv
m3q/f4IYms69Db7/y9AYuaoPUfgGTYdI17CzJnGcxxTCt+X5OW8JE4iDdw9n/iWeIH6Fbw+iMFUe
zAHEwRgluBThFB1MIOGE79jTxBXhNcMCax/aCmhgCFmR4DUgCi0sqh1wH1mEa4whK5abl62aqn9R
etfQVEIPsibBu4Ao3Hv8u9mBpjqmkDUKXg2i8Ib5akghDnqIsagID5D1C1854wONRobBH2NHMfgd
SC6sqAlEIcV3vEMcpahs1uBjRT1AAjt3uiMbXhv3CivpCBLQjfL2hSxhiJZ+UZmvIvQhAXQQYVEJ
RpAM7lF2XNX3kLuqEM9eEQe6BD6jnHHn/wNy2d0aBr+cYTK/RoT5bvSLwHwW4QWypBfE0NR2HPya
h1dqTpDbYnQgGd0igqZdpJ4GP3b4rTJy3wUmEKURanDpCqLU9HRXd4oCNqIE/+JtwVnZRR0FuNaF
KPQReZrI29jIEuyj8sM+YmStCFE6VvxWClE4heWw8Bp5XEHPEIOsM087b74gDfcqve26v8WfivEG
sctPuA2AMySYL8YzJNsbfdYRRKmNbfysiiEk+0RubUMcdfHh7xumVte2Jq23BiSwr7D0H4Dy6gkR
rJU+hwAGSGApuoR41EURDllNiAdtFJAh6wRTSAZj1GEtWdHxkzUfuEIBHrMSnKKNN4wwwztecIMK
Iqw8y7Isy7Isy7Isy7Isy/oPdoxBavrY/9QAAAAASUVORK5CYII=`;

export const GESTURE_GREEN_BASE64 = `data:image/png;base64,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`;

export const DESCRIPTION_BLACK_BASE64 = `data:image/png;base64,
iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAATlBMVEUAAAAAAAAAAAAAAAAAAAAA
AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
AAAAAADEoqZZAAAAGnRSTlMAJIPH3/9vBIv7t48o1/fj56NAswy/k+ubMOOzlt8AAADMSURBVHgB
7dSFAcJQFEPRAH11x/dflAGQlAYnd4Hz9cE5d7nFcpUEKcXssrwImiBkZfAUoQqeItRF6IK+AUFo
glcpQhs8KEJMCETQASLoABF0gAg6QAQdoIIOcEEHuKADXFABLqgAF1SACyrABRXgggpwQQWIIAAX
hCcBqJ4NoHo2gEoEeM8DDBgwYACknwUMGPCoMGDAo8KAATEDBmCgA6sPqRVYQ0gtwRpDqViAtg6h
HLxNE7PbZpgizN7DLsO0xmEfd5ccjriYc+4EXVRRUDhaERQAAAAASUVORK5CYII=`;

export const DESCRIPTION_GREY_BASE64 = `data:image/png;base64,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`;

export const DESCRIPTION_LIGHT_GREY_BASE64 = `data:image/png;base64,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`;

export const FACT_CHECK_BLACK_BASE64 = `data:image/png;base64,
iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAYFBMVEUAAAAAAAAAAAAAAAAAAAAA
AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD6T+iNAAAAIHRSTlMAJIPH3/+/exgEi/v3c6OTMJurb7s8
81PXIOcoQGfjDDpNdHEAAAEWSURBVHgB7dbFYQRBEENRDTMuc/5Z+qRTtbFlrh+A3u4wflqe53lJ
muVFZHlZ1QjXtF0hqR/C+2Uha0SgqRA2wDQXyvraAEshrTJArgVKAxTacguI++2AAw4g0L8AHHAg
rmH9XGCDZpUCZh8U1AD3KagB7lNQA9ynsBUD3Ge7vQjYH47hfdGNtt+hPob3YwHuA6dzYF8AcB+4
nO1+NMB9CmZfAVzBLjezrwDWBszsCwAKZl8HUAjvC240CmZfABiB+2qAAvfVAAXuqwEK3NcDFLiv
ByhwXw5QuO7909EBB94JiIMDDjhwN8BZC2QGGLVAaoBroaxLYFqVQAvb41jIKhuEBNl/mBqEu47n
Irp8meF5nvfDegJFqGk/uMWylAAAAABJRU5ErkJggg==`;

export const FACT_CHECK_LIGHT_GREY_BASE64 = `data:image/png;base64,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`;

export const PHOTO_BLACK_BASE64 = `data:image/png;base64,
iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAACFElEQVR4Ae3bAWQbUQCH8eFQFEMw
QBAABAMEAQIAAAiKAaA4FEExFEMBwRDAAMMBAiiGYRjgEAzBAMXh7VOm9DzNtXcvvcv38QOA95fc
O5F31iAzMzMzMzMzM5vgGncoEQauxBZX+ICjleEGFcKJusflsQ5/i/BAGyTt1kOvuUSSpgg1uk/1
TFh72FFX6Lz4TUdbdF5QVOkAx5agIAdwADmAA8gBHEAO4AByAAeQAziAHMAB5AAOcCIcwAHkAA4g
B3AAOYADyAEcQA4QsUbhAMfxA2cYYecAae0xxv9mqBwgjQoLPC13gDRWiFU4QLcKRKs/Dxxgje8I
LSjxHs81Q+UAj7eUc/xq4a+iUxxafpoDxG8pY/xBeKELNK041QEqLFr8aviKeKmeBwlKcUtZIjTw
E2doXnz0QQ9Q4Lk+IxzgL8Z4bfnwB2h2S8kOvBkt0FbF0AdodEs54Ga0QpuNsBvyAEs0bYJ95Gss
Q9vNUA1xgDVe2vzJoZQYoavyYQxQf9l6TRcIqPARXVcMZYA9xmijL/iEFI2w6/sAVcu3lAwpm6Hq
8wAr9L28rwMUGEpFnwaIv2ylL/3zIEENXrYG1QxVHwZYYqjlb3MAOYADyAEcQDt0XvxHc92h8zYe
dNQ1Om+OoJoKEyTpmwdec4NkneM3gh5skYGSjuAnAbfIcLTm2JzY7ajEGlOYmZmZmZmZmZkd1D+h
HFrIN6DOpgAAAABJRU5ErkJggg==`;

export const PHOTO_LIGHT_GREY_BASE64 = `data:image/png;base64,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=`;
